export const TRANSLATIONS_PT = {
  CameraErrorPopup: {
    InfoErrors: {
      deviceInUse:
        '<div>Não é possível acessar a câmera.</div><div> Outro aplicativo está usando sua câmera.</div><div> Libere a câmera e tente novamente.</div>',
      deviceNotFound:
        '<div>Câmera não encontrada.</div><div> Certifique-se de que uma câmera esteja conectada ao seu computador e esteja funcionando corretamente.</div>',
      failedToAccessTheDevice:
        '<div>Ocorreu um erro ao tentar acessar a câmera.</div><div> Tente novamente.</div>',
    },
    InfoGuide: {
      android:
        '<ol><li>Vá para<b> Configurações</b> &gt;<b> Aplicativos</b> &gt; Escolha seu navegador (Chrome, Firefox etc.).</li><li> Selecione <b> Permissões</b> .</li><li> Selecione <b> Câmera</b> e <b> Permitir durante o uso do aplicativo</b> ou<b> Perguntar sempre</b> .</li></ol>',
      chrome:
        '<ol><li>Clique no<b> ícone de configurações</b> na barra de endereços.</li><li> Selecione<b> Configurações do site</b> .</li><li> Encontre a<b> Câmera</b> e selecione<b> Permitir</b> no menu suspenso.</li></ol>',
      default: '<ol><li>Acesse as configurações do navegador.</li><li> Ligue a câmera.</li></ol>',
      edge: '<ol><li>Clique no<b> ícone de configurações</b> na barra de endereço.</li><li> Selecione as<b> Permissões</b> deste site.</li><li> Em<b> Câmera</b> , selecione<b> Permitir</b> .</li></ol>',
      firefox:
        '<ol><li>Clique no<b> ícone de configurações</b> ao lado do URL.</li><li> Clique em<b> Permissões</b> .</li><li> Certifique-se de que a opção<b> Usar a câmera</b> esteja definida como Permitir.</li></ol>',
      ios: '<ol><li>Vá para<b> Configurações</b> > <b> Privacidade e segurança</b> > <b> Câmera</b> .</li><li> <b> Selecione</b> o navegador que você está usando (por exemplo, Safari, Chrome).</li><li> Caso seja solicitado no Safari, selecione<b> Permitir</b> quando for solicitada a permissão para usar a câmera.</li></ol>',
      safari:
        '<ol><li>Vá para<b> Safari</b> > <b> Configurações deste site</b> .</li><li> Ao lado de<b> Câmera</b> , selecione<b> Permitir</b> .</li></ol>',
    },
    description: 'Para iniciar o vídeo com seu tutor, permita o acesso à câmera no seu navegador',
    resolvedBtn: 'Ok, alterei!',
    skipBtn: 'Continuar sem câmera',
    title: 'Queremos ver você!',
  },
  ChooseAnotherLevel: 'Selecione outro nível',
  CommunicationProblemModalDescription:
    'Nossos servidores não estão respondendo. Por favor, tente novamente.<br /> Se o problema persistir, entre em contato conosco pelo e-mail info@eb.com',
  CommunicationProblemModalTitle: 'Ops! Tivemos um problema técnico.',
  GoogleLoginProblemDescription:
    'Seu professor precisa registrar você e sua turma antes de começar. Uma vez que sua turma estiver registrada, você poderá começar sua jornada com o Hello!',
  GoogleLoginProblemTitle: 'Ops! Ocorreu um problema.',
  IAlreadyHaveAnAccount: 'Eu já tenho uma conta',
  MicrophoneInfoErrors: {
    deviceInUse:
      '<div>Não foi possível acessar o microfone. </div><div>Outro aplicativo está usando seu microfone. </div><div>Solte-o e tente novamente. </div>',
    deviceNotFound:
      '<div>Microfone não encontrado. </div><div>Verifique se o microfone está conectado ao computador e se está funcionando corretamente. </div>',
    failedToAccessTheDevice:
      '<div>Ocorreu um erro ao tentar acessar o microfone. </div><div>Tente novamente. </div>',
  },
  MicrophoneInfoGuide: {
    android:
      '<ol>\n      <li>Vá até <b>Configurações</b> > <b>Aplicativos</b> > Selecione seu navegador (Chrome, Firefox etc.).</li>\n      <li>Clique em <b>Permissões</b>.</li>\n      <li>Clique em <b>Microfone</b> e selecione <b>Permitir durante o uso do aplicativo</b> ou <b>Perguntar sempre</b>.</li>\n    </ol>',
    chrome:
      '<ol>\n      <li>Clique no <b>ícone de configurações</b> na barra de endereços.</li>\n      <li>Selecione <b>"Configurações do site"</b>.</li>\n      <li>Procure por <b>Microfone</b> e selecione <b>Permitir</b> no menu suspenso.</li>\n    </ol>',
    default:
      '<ol>\n      <li>Ir para as configurações do navegador.</li>\n      <li>Ligue o microfone.</li>\n    </ol>',
    edge: '<ol>\n      <li>Clique no <b>ícone de configurações</b> na barra de endereços.</li>\n      <li>Selecione <b>Permissões</b> para esse site.</li>\n      <li>Abaixo de <b>Microfone</b>, selecione <b>Permitir</b>.</li>\n    </ol>',
    firefox:
      '<ol>\n      <li>Clique no <b>ícone de configurações</b> ao lado do URL.</li>\n      <li>Clique em <b>"Permissões"</b>.</li>\n      <li>Certifique-se de que <b>"Usar o microfone"</b> esteja configurado como "Permitir".</li>\n    </ol>',
    ios: '<ol>\n      <li>Vá até <b>Configurações</b> > <b>Privacidade e Segurança</b> > <b>Microfone</b>.</li>\n      <li><b>Acione</b> o botão relativo ao navegador que estiver usando (exemplo: Safari, Chrome).</li>\n      <li>Caso esteja usando o Safari, clique em <b>"Permitir"</b> quando vir a mensagem pedindo permissão para usar o microfone.</li>\n    </ol>',
    safari:
      '<ol>\n      <li>Vá até <b>Safari</b> > <b>Configurações deste site</b>.</li>\n      <li>Ao lado do <b>Microfone</b>, selecione <b>Permitir</b>.</li>\n    </ol',
  },
  MicrophoneInfoInOrderTo:
    'Para algumas das atividades, você precisará aprovar o uso do microfone no seu navegador',
  MicrophoneInfoInOrderToQuiz:
    'Para realizar essa atividade, será preciso permitir o uso do microfone em seu navegador',
  MicrophoneInfoWeWantTo: 'Queremos ouvir você!',
  MinasLoginProblemDescription:
    'Sua conta não está autorizada a fazer login pelo Google. Entre em contato com seu professor/gestor escolar.',
  UnauthorizedLoginProblemDescription:
    'Este endereço de e-mail não está autorizado a usar o Hello Britannica. Entre em contato com o seu professor/gestor escolar. ',
  UserNotConfirmedException:
    'Sua conta não foi verificada. Insira o código de verificação enviado para o seu e-mail.',
  about: 'Sobre',
  accountVerifiedCanLoginNow: 'Sua conta foi verificada. Você pode fazer login agora.',
  accountVerifiedSigningIn: 'Your account is verified. Signing you in…',
  account_settings: 'Configurações da conta',
  achievmentsSection: {
    feedback: 'Você mostrou algumas habilidades extraordinárias!',
    weeklyAchievement: 'Conquista da semana',
  },
  active: 'Ativo',
  activities: 'Atividades',
  addNewClass: 'Adicionar nova turma',
  addYourClasses: 'Adicione suas turmas',
  admin: {
    accountDetailsPage: {
      accountIdRequired: 'É necessário inserir o ID da conta para atualizar',
      accountNotFound: 'Conta não encontrada.',
      back: 'Voltar',
      editAccount: 'Editar conta',
      failedToLoad: 'Não foi possível carregar os detalhes da conta',
      failedToUpdate: 'Não foi possível atualizar a conta',
      loadingAccountDetails: 'Carregando detalhes da conta...',
    },
    accountInfoCard: {
      accountType: 'Tipo de conta',
      brazil: 'Brasil',
      country: 'País',
      createSchoolHint:
        'Clique aqui para criar uma escola e integrar usuários ao Hello Britannica.',
      creationDate: 'Data de criação',
      customerPilot: 'Cliente piloto',
      customerProduction: 'Cliente ativo',
      expirationDate: 'Data de expiração',
      here: 'aqui',
      learningLanguage: 'Idioma de aprendizagem',
      licensesRemaining: 'Licenças restantes',
      loginProvider: 'Provedor de login',
      nativeLanguage: 'Língua nativa',
      no: 'Não',
      noOfDistricts: 'Número de unidades/municípios',
      noOfSchools: 'Número de escolas',
      notSet: 'Não definido',
      registeredUsers: 'Usuários registrados',
      signInOptions: 'Opções de login',
      systemType: 'Tipo de sistema',
      tutorActive: 'Tutor ativo',
      tutorType: 'Tipo de tutor',
      userLimit: 'Limite de usuários',
      yes: 'Sim',
    },
    accountsListPage: {
      createNewAccount: '+ Criar nova conta',
      newAccount: 'Nova conta',
      title: 'Contas',
    },
    bimloaFilter: {
      choose: 'Selecionar',
      chooseDate: 'Selecionar data',
      chooseDateRange: 'Selecionar período',
      failedToFetchSuggestions: 'Não foi possível obter sugestões',
      failedToLoadSuggestions: 'Não foi possível carregar sugestões',
      last30Days: 'Últimos 30 dias',
      last7Days: 'Últimos 7 dias',
      range: 'Intervalo',
      specificDate: 'Data específica',
    },
    bulkActions: {
      changeLevel: {
        chooseLevel: {
          description:
            "Change the level of {{count}} students to a new level. <b>Changing students' level will reset their scores and progress. Any previous data will be lost.</b> Note that if students are at different levels, proceeding will set all of them to the new level.",
          hasNonActivedStudentsNote:
            'Note: non-active students will not be affected by the level change.',
          level: 'Level',
          mixedLevelsWarning:
            'ℹ️ The selected students are at different levels. Proceeding will set all of them to {{newLevel}}.',
          selectLevel: 'Select a Level',
          submitButton: 'Confirm Change',
          theNewLevel: 'the new level',
          title: "Change Students' level",
        },
        currentLevel: 'Current Level',
        failure: {
          description: 'Please try again.',
          title: 'No students could be updated.',
        },
        partialSuccesses: {
          description:
            '{{completed}} of {{total}} students have been successfully moved to {{newLevel}}. The following students could not be updated:',
        },
        report: {
          actionChangeLevel: 'Change Level',
          class: 'Class',
          fileName: 'Bulk Change Level Report',
          newLevel: 'New Level',
          previousLevel: 'Previous Level',
        },
        successes: {
          title: 'All {{count}} students have been successfully moved to {{newLevel}}.',
        },
      },
      classes: {
        classesSelected_one: '1 turma selecionada',
        classesSelected_other: '{{count}} Turmas selecionadas',
        deleteClasses_one: 'Excluir turma',
        deleteClasses_other: 'Excluir turmas',
      },
      common: {
        action: 'Action',
        classAndGrade: 'Class & Grade',
        failureDescription: 'Please try again later.',
        failureTitle: 'We had a problem',
        name: 'Name',
        partialSuccessTitle: '⚠️ Partial Success',
        teacher: 'Teacher',
      },
      deleteClasses: {
        apiReason: 'Bulk class deletion from school admin',
        confirm: {
          deleteAnywayButton: 'Excluir turmas',
          titleWithStudents: 'Tem certeza?',
          understandWithStudents:
            'Compreendo que os alunos selecionados e seu progresso serão excluídos permanentemente.',
          warningEmpty:
            'Tem certeza de que deseja excluir essas turmas? Esta ação não pode ser desfeita.',
          warningWithStudents:
            'Você está prestes a excluir {{classCount}} turmas contendo {{studentCount}} alunos selecionados. A exclusão dessas turmas também excluirá os alunos e os removerá permanentemente da plataforma. Eles não poderão mais fazer login e seus dados de progresso serão perdidos. Uma vez confirmada, essa ação não poderá ser desfeita.',
        },
        partialSuccesses: {
          description: 'Não foi possível excluir algumas turmas. Consulte a tabela a seguir.',
          statusColumn: 'Status',
          statusDeleted: 'Turmas excluídas',
          statusFailed: 'A exclusão falhou.',
          studentsDeletedRatio: '{{deleted}}/{{total}}',
          tableStudentsDeleted: 'Alunos excluídos',
        },
        report: {
          actionDelete: 'Excluir',
          className: 'Nome da turma',
          fileName: 'Excluir relatórios das turmas em lote',
          statusFailure: 'Falha',
          statusSuccess: 'Sucesso',
        },
        successes: {
          studentsDeletedFollowUpPlural:
            'Além disso, {{count}} alunos foram excluídos com sucesso. Os alunos excluídos foram desconectados de todas as sessões ativas e não poderão fazer login novamente.',
          studentsDeletedFollowUpSingular:
            'Além disso, 1 aluno foi excluído com sucesso. Ele foi desconectado de todas as sessões ativas e não poderá fazer login novamente.',
          title: 'As turmas selecionadas foram excluídas com sucesso!',
        },
      },
      deleteStudents: {
        chooseReason: {
          confirmationCheckbox:
            'Compreendo que os alunos selecionados e seu progresso serão excluídos permanentemente.',
          description:
            'Você está prestes a excluir {{num}} alunos selecionados. A exclusão desses alunos os removerá permanentemente da plataforma. Eles não poderão mais fazer login e seus dados de progresso serão perdidos. Uma vez confirmada, essa ação não poderá ser desfeita.',
          reason: 'Motivo',
          subDescription:
            'Isso nos ajuda a rastrear por que os alunos são removidos da plataforma.',
          subTitle: 'Por gentileza, forneça um motivo.',
          submitButton: 'Excluir alunos',
          title: 'Tem certeza?',
          why: 'Por quê?',
        },
        partialSuccesses: {
          description:
            'Os alunos excluídos tiveram suas sessões encerradas e não poderão fazer login novamente.',
        },
        report: {
          class: 'Turma',
          fileName: 'Excluir relatórios dos alunos em lote',
        },
        successes: {
          description:
            'Os alunos excluídos tiveram suas sessões encerradas e não poderão fazer login novamente.',
          title: 'Os alunos selecionados foram excluídos com sucesso!',
        },
      },
      downloadChanges: {
        downloadButton: 'Fazer download',
        text: 'de uma lista das alterações',
      },
      moveStudents: {
        availableSeats: {
          description:
            'Você selecionou {{selectedCount}} alunos, mas apenas {{availableSeats}} vagas estão disponíveis em {{destinationClass}}.\nSelecione uma turma diferente ou uma quantidade menor de alunos.',
          title: '⚠️ Essa turma não tem vagas suficientes.',
        },
        chooseDestination: {
          description:
            'Transfira {{num}} alunos selecionados para uma nova turma. O progresso, as pontuações e o histórico de acessos dos alunos serão preservados.',
          full: 'Cheia',
          selectClass: 'Selecione uma turma',
          spotsLeft: '{{num}} vagas restantes',
          subDescription:
            'O progresso, as pontuações e o histórico de acessos dos alunos serão preservados durante a transferência.',
          subTitle: 'Selecione a classe de destino',
          submitButton: 'Transferir alunos',
          title: 'Transferir alunos',
        },
        differentGrade: {
          description:
            'Um ou mais alunos selecionados estão atualmente alocados em uma turma de ano/série diferente da turma de destino.',
          moveAllButton: 'Transferir mesmo assim',
          moveSameButton: 'Transferir sem esses alunos',
          title: '⚠️ Alguns alunos estão em um ano/série diferente.',
        },
        partialSuccesses: {
          description: 'Os alunos que não foram transferidos permaneceram em sua turma de origem.',
        },
        report: {
          actionMove: 'Transferir',
          fileName: 'Transferir relatórios dos alunos em lote',
          moveFromClass: 'Transferir de turma',
          moveFromGrade: 'Transferir de ano/série',
          moveFromTeacher: 'Transferir do professor',
          moveToClass: 'Transferir para turma',
          moveToGrade: 'Transferir para ano/série',
          moveToTeacher: 'Transferir para professor',
        },
        studentsTable: {
          currentClassAndGrade: 'Turma e ano/série atuais',
          destinationClassAndGrade: 'Turma e ano/série de destino',
        },
        successes: {
          description:
            'O progresso, as pontuações e o histórico de acessos dos alunos serão preservados.',
          title: 'Os alunos selecionados foram transferidos com sucesso!',
        },
      },
    },
    changePassword: {
      changePassword: 'Alterar senha',
      confirmPassword: 'Confirmar senha',
      currentPassword: 'Senha atual',
      invalidPassword: 'Senha inválida',
      newPassword: 'Nova senha',
      password: 'Senha',
      passwordsDontMatch: 'As senhas não coincidem',
      reEnterNewPassword: 'Inserir novamente a nova senha',
      requirements: 'Requisitos:',
    },
    classCodeModal: {
      copyClassCode: 'Copiar código',
      copyClassCodeDescription:
        'Copie o código e envie-o aos alunos para que eles possam acessar a plataforma!',
      yourClassCode: 'Seu código de turma:',
    },
    cognitoErrors: {
      NetworkError: 'Erro de rede. Verifique sua conexão com a internet e tente novamente.',
      invalidUsernameOrPassword: 'E-mail ou senha inválidos',
    },
    collapseSidebar: 'Recolher barra lateral',
    comingSoon: 'Em breve',
    common: {
      back: 'Voltar',
      cancel: 'Cancelar',
      copied: 'Copiado!',
      loading: 'Carregando...',
      save: 'Salvar',
      saving: 'Salvando...',
      search: 'Buscar',
      tabs: {
        classes: 'Turmas',
        general: 'Informações gerais',
        students: 'Alunos',
        teachers: 'Professores',
      },
      tryAgain: 'Try Again',
      tryAgainLater: 'Please try again later.',
    },
    desktopOnlyMessage:
      'To watch your school’s details, reports and dashboards, please use the desktop version.',
    dir: 'ltr',
    districtDetailsPage: {
      back: 'Voltar',
      editDistrict: 'Editar unidade/município',
      info: {
        country: 'País',
        creationDate: 'Data de criação',
        email: 'E-mail',
        expirationDate: 'Data de expiração',
        location: 'Local',
        manager: 'Gestor',
        nativeLanguage: 'Língua nativa',
        numSchools: 'Número de escolas',
        numSchoolsHint: 'Ao menos uma escola deve estar vinculada para usar a plataforma.',
        registeredUsers: 'Usuários registrados',
      },
      notFound: 'Unidade/município não encontrado.',
      schoolsTable: {
        addNew: '+ Adicionar novo',
        columns: {
          contact: 'Contato',
          school: 'Escola',
          students: 'Alunos',
          teachers: 'Número de professores',
        },
        title: 'Escolas',
      },
    },
    districtsListPage: {
      columns: {
        activeUsers: 'Usuários ativos',
        admin: 'Administrador da unidade/município',
        adminEmail: 'E-mail do administrador da unidade/município',
        district: 'Unidade/município',
        registeredUsers: 'Usuários registrados',
        status: 'Status',
      },
      filters: {
        admin: 'Administrador da unidade/município',
        adminEmail: 'E-mail do administrador da unidade/município',
        district: 'Unidade/município',
        schools: 'Escolas',
      },
      newDistricts: 'Novas unidades/municípios',
      title: 'Unidades/municípios',
    },
    districtsTable: {
      addNew: '+ Adicionar unidade/município',
      columns: {
        contact: 'Contato',
        district: 'Unidade/município',
        schools: 'Número de escolas',
        users: 'Usuários',
      },
      noResults: 'Não existem unidades/municípios neste contrato.',
    },
    download: 'Fazer download',
    downloadAndView: 'Fazer download e visualizar',
    dropDown: {
      placeholder: 'Selecionar',
    },
    dynamicForm: {
      notification: {
        classCreated: 'A turma foi criada com sucesso.',
        classEdited: 'A turma foi editada com sucesso.',
        generalError: 'Ocorreu um erro. Tente novamente mais tarde',
        schoolNameUpdated: 'O nome da escola foi editado com sucesso',
        studentDeleted: 'O aluno foi excluído com sucesso.',
        teacherDeleted: 'O professor foi excluído com sucesso.',
        teacherEdited: 'Os dados do professor foram editados com sucesso.',
      },
      popups: {
        changeStatus: {
          cancel: 'Não, manter atual',
          confirm: 'Sim, alterar',
          subTitle: 'Tem certeza de que deseja alterar o status? Esta ação não pode ser desfeita.',
          title: 'Alterar status?',
        },
        editSchoolName: {
          Subtitles: 'Insira o nome da escola',
          label: 'Novo nome',
          ok: 'Alterar nome',
          title: 'Alterar nome da escola',
        },
        newAccount: {
          cancel: 'Cancelar',
          confirm: 'Eu concordo',
          subTitle:
            'Ao criar a conta, você concorda com nossos termos e condições de gerenciamento de conta e tratamento de dados de usuário.',
          title: 'Termos e condições',
        },
        newClassMessage: {
          Subtitles:
            'Seus alunos receberam instruções por e-mail para redefinir suas senhas. Após o login, eles farão um teste de nivelamento. Com base nos resultados, serão alocados no nível apropriado e poderão iniciar suas jornadas de aprendizagem.',
          title: 'A turma foi criada com sucesso!',
        },
        newRegion: {
          ok: 'Ok',
          subTitle:
            'Foi enviado um e-mail e uma senha temporária a %region admin first and last name% com instruções de login do HelloHub.',
          title: '%regionName% foi criado com sucesso.',
        },
        newTeacherMessage: {
          Subtitles:
            'Os professores receberam instruções por e-mail para redefinir suas senhas. Depois disso, poderão começar a usar o Hello Britannica.',
          title: 'Os professores foram adicionados com sucesso!',
        },
        saved: {
          subTitle: 'Suas alterações foram salvas!',
          title: 'Salvo!',
        },
        turnOffDeal: {
          keepOn: 'Não, continuar',
          subTitle:
            'Tem certeza de que deseja desativar este contrato? Essa ação não pode ser desfeita.',
          title: 'Desativar o contrato?',
          turnOff: 'Sim, desativar',
        },
      },
      validation: {
        email: 'Insira um e-mail válido.',
        invalidFormat: 'This field contains invalid characters.',
        max: 'Valor máximo é {{value}}',
        maxLength: 'Tamanho máximo é {{length}}',
        min: 'Valor mínimo é {{value}}',
        minLength: 'Tamanho mínimo é {{length}}',
        required: 'Este campo é obrigatório',
      },
    },
    error: {
      description: 'Houve um erro ao processar seu pedido. Tente novamente mais tarde.',
    },
    expandSidebar: 'Expandir barra lateral',
    form: {
      editTeacher: 'Editar professor',
      email: 'E-mail',
      firstName: 'Nome',
      lastName: 'Sobrenome',
    },
    genericTable: {
      classes: {
        activeStudents: 'Alunos ativos',
        coTeacher: 'Professor colaborador',
        grade: 'Ano/série',
        name: 'Nome da turma',
        students: 'Alunos',
        teacher: 'Nome do professor',
      },
      clearSearch: 'Limpar pesquisa',
      clearSelection: 'Limpar seleção',
      downloadAriaLabel: 'Fazer download',
      noRecords: 'Não há itens a serem exibidos.',
      noResultsForSearchQuery: 'Não foram encontrados resultados para “{{searchQuery}}”',
      searchDescription_one: '{{count}} resultados encontrados para “{{searchQuery}}”',
      searchDescription_other: '{{count}} resultados encontrados para “{{searchQuery}}”',
      teachers: {
        activeStudents: 'Alunos ativos',
        firstLogin: 'Primeiro login',
        lastLogin: 'Último login',
        name: 'Nome',
        numClasses: 'Turmas',
        numStudents: 'Alunos',
      },
    },
    gradeLabel: 'Ano/série',
    historyPage: {
      dealNameLabel: 'nome do contrato:',
      failedToLoad: 'Não foi possível carregar os dados do histórico. Tente novamente mais tarde.',
      filters: {
        action: 'Ação',
        date: 'Data',
        dealName: 'Nome da conta',
        dealType: 'Tipo de conta',
        language: 'Idioma',
        lms: 'Plataforma LMS',
      },
      title: 'Histórico',
    },
    instructions: 'Instruções',
    lang: 'ing',
    loginPage: {
      back: 'Voltar',
      changePasswordForm: {
        confirmPassword: 'Confirme a senha',
        description: 'Escolha sua senha',
        errors: {
          confirmPasswordDontMatch: 'As senhas não coincidem',
          confirmPasswordIsRequired: 'É obrigatório confirmar a senha',
        },
        loadingText: '',
        password: 'Senha',
        passwordChangedSuccessfully: 'Senha alterada com sucesso',
        passwordPlaceholder: 'Senha',
        submit: 'Concluído',
        titel: 'Bem-vindo(a)!',
      },
      forgotPasswordForm: {
        confirmPassword: 'Confirmar senha',
        description: 'Insira suas informações',
        email: 'E-mail',
        emailFieldText:
          'Caso o e-mail seja válido, você receberá um código de verificação para continuar o processo de redefinição de senha. ',
        emailPlaceholder: 'exemplo@email.com',
        errors: {
          confirmPasswordDontMatch: 'As senhas não coincidem',
          confirmPasswordIsRequired: 'É obrigatório confirmar a senha',
          emailFormat: 'E-mail inválido',
          emailIsRequired: 'E-mail é obrigatório',
          verificationCodeIsRequired: 'O código é obrigatório',
          verificationCodeMinimumLength: 'O código deve ter no mínimo 6 caracteres',
        },
        loadingText: '',
        newPassword: 'Insira a nova senha',
        passwordChangedSuccessfully: 'Senha alterada com sucesso',
        passwordPlaceholder: 'Sua senha aqui',
        sendEmailAgain: 'Não recebeu o código? Enviar de novo',
        submit: 'Enviar',
        titel: 'Redefinir sua senha',
        verificationCode: 'Código de verificação',
        verificationCodePlaceholder: '6 dígitos',
      },
      loginForm: {
        description: 'Insira suas informações',
        errors: {
          passwordIsRequired: 'A senha é obrigatória',
          usernameIsRequired: 'O e-mail é obrigatório',
        },
        forgotPassword: 'Esqueci a senha',
        loadingText: 'Fazendo seu login em...',
        password: 'Senha',
        submit: 'Fazer login',
        titel: 'Bem-vindo(a)!',
        username: 'E-mail',
      },
      passwordRequirements:
        '<div> <div>Mínimo de 8 caracteres</div> <div>Contém ao menos 1 número</div> <div>Contém ao menos 1 letra maiúscula</div> <div>Contém ao menos 1 letra minúscula</div> </div><div>Contém ao menos 1 caractere especial</div></div>',
      verificationCodeForm: {
        accountVerified: 'Sua conta foi verificada.',
        description: 'Insira o código de verificação ',
        errors: {
          verificationCodeIsRequired: 'O código de verificação é obrigatório',
          verificationCodeMinimumLength: 'O código deve ter no mínimo 6 dígitos',
        },
        loadingText: 'Fazendo seu login em...',
        submit: 'Fazer login',
        titel: 'Bem-vindo(a)!',
        verificationCode: 'Código de verificação',
        verificationCodePlaceholder: 'Insira o código de verificação',
      },
    },
    pageHeader: {
      edit: 'Editar',
      groupedActiveFiltersSummary: 'Filtros: {{count}}',
    },
    regionsListPage: {
      welcomeMessage:
        'Esta plataforma permite criar e gerenciar regiões/unidades na plataforma <strong>Hello Britannica English Learning</strong>. Vá em frente e crie sua primeira região/unidade!',
      welcomeTitle: 'Bem-vindo, administrador!',
    },
    schoolDetailsPage: {
      classes: {
        actions: {
          addStudent: 'Adicionar aluno',
          delete: 'Excluir',
          downloadReport: 'Fazer download do relatório de turma',
          edit: 'Editar',
          viewClass: 'Ver turma',
        },
        backToClasses: 'Voltar para turmas',
        classDeletedSuccessfully: 'A turma foi excluída com sucesso.',
        className: 'Nome da turma',
        classNotFound: 'Turma não encontrada',
        continueToUploadingStudents: 'Continue a fazer upload dos alunos',
        copyClassCode: 'Código copiado com sucesso',
        create: 'Criar',
        deleteClassModal: {
          confirmButton: 'Excluir',
          description:
            'Excluir esta turma também excluirá <strong>{{count}}</strong> alunos ativos da turma, incluindo seus dados de progresso e histórico. Uma vez confirmada, esta ação não poderá ser desfeita.',
          descriptionEmpty:
            'Você está prestes a excluir sua turma. Esta ação não pode ser desfeita.',
          descriptionSingular:
            'Excluir esta turma também excluirá <strong>1</strong> aluno ativo da turma, incluindo seus dados de progresso e histórico. Uma vez confirmada, esta ação não poderá ser desfeita.',
          title: 'Tem certeza?',
        },
        deleteTeacherModal: {
          areYouSure: {
            description:
              'O professor {{teacherName}} tem {{numberOfStudents}} alunos em {{numberOfClasses}} turmas. Você quer excluir todos os alunos permanentemente?',
            title: 'Tem certeza?',
          },
          cancel: 'Cancelar',
          classesWithoutStudents: {
            line: 'Nome da turma - <strong>{{name}}</strong>.',
            lineWithClassCode:
              'Nome da turma - <strong>{{name}}</strong> e código da turma - <strong>{{classCode}}</strong>',
            title: 'As seguintes turmas também serão excluídas: ',
          },
          continue: 'Continuar',
          done: {
            btn: 'Concluído',
            deleted0StudentsXClasses: 'Foram excluídas {{deletedClasses}} turmas vazias.',
            deletedNStudentsXClasses:
              'Foram excluídos {{deletedStudents}} alunos e {{deletedClasses}} turmas.',
            reassignedTo1Teacher:
              '{{numberOfClasses}} turmas e todos os alunos associados foram reatribuídos ao professor {{teacherName}}.',
            reassignedToNTeachers:
              '{{numberOfClasses}} turmas e todos os alunos associados foram reatribuídos a outros professores.',
            teacherHasBeenRemoved: '{{teacherName}} foi excluído.',
            title: 'Concluído!',
          },
          ok: 'Ok',
          payAttention: {
            description:
              'Você está prestes a excluir <strong>{{teacherName}}</strong> o professor e todos os dados associados (turmas, alunos, dados de progresso dos alunos e códigos de turma). Esta ação não pode ser desfeita.',
            title: 'Preste atenção!',
          },
          selectAction: {
            delete: 'Excluir',
            description:
              'Você pode excluir a turma ou atribuí-la a outro professor. Conclua as alterações de matrícula dos alunos individualmente antes de excluir o professor.',
            forAllClasses: 'Mesmo professor para todas as turmas',
            keepRemainingTeacher: 'Manter "{{name}}"',
            moveAllTo: 'Transferir todas as turmas para:',
            title: 'Selecione uma ação',
            to: 'Turma "{{name}}" para',
          },
        },
        editClass: 'Editar turma',
        errorLoading: 'Erro ao carregar as turmas: {{error}}',
        failedToFetch: 'Não foi possível localizar as turmas',
        filters: {
          classCode: 'Código de turma',
          classCodePlaceholder: 'Pesquisar código de turma',
          classSearchPlaceholder: 'Pesquisar turma',
          gradeSearchPlaceholder: 'Pesquisar ano/série',
          teacherSearchPlaceholder: 'Pesquisar professor',
        },
        gradeLabel: 'Ano/série',
        gradeOption1st: '1º ano (EFAI)',
        gradeOption2nd: '2º ano (EFAI)',
        gradeOption3rd: '3º ano (EFAI)',
        levelControl: {
          allowIndividualAdvancementLabel: 'Automatic Level Progression',
          allowIndividualAdvancementTooltip:
            'Disabling will stop students in this class who complete a level from automatically continuing to the next level.',
          cancelButton: 'Cancel',
          confirmButton: 'Confirm',
          confirmButtonChangeLevel: 'Change Level',
          confirmButtonDisableLevelProgression: 'Disable Level Progression',
          confirmButtonDisableLevelTest: 'Disable Level Test',
          confirmButtonEnableLevelProgression: 'Enable Level Progression',
          confirmButtonEnableLevelTest: 'Enable Level Test',
          confirmButtonSetLevel: 'Set Level',
          confirmTitle: 'Are you sure?',
          defaultStartingLevelLabel: 'Initial Level',
          defaultStartingLevelPlaceholder: 'Initial Level',
          defaultStartingLevelRequired: 'Please select a default starting level.',
          placementTestRequiredLabel: 'Level Test',
          placementTestRequiredTooltip:
            'Disabling will skip the level placement test for students in this class. You will be required to assign their starting level.',
          warnings: {
            advancementTurnedOff:
              'Turning off automatic level progression means students will stay at their completed level when they finish it. They can repeat activities for more practice.',
            advancementTurnedOn:
              'Turning on automatic level progression means students in this class who have already completed their level will automatically move ahead to the next level on their next login. Any students in this class who complete their level in the future will also move ahead immediately.',
            advancementTurnedOnExistingClass:
              'Turning on automatic level progression means any students who already completed their level will move ahead on their next login. Students who complete their level in the future will also move ahead automatically.',
            advancementTurnedOnNewClass:
              'Turning on automatic level progression means students will move ahead to the next level automatically when they complete their current one.',
            defaultLevelChanged:
              'Changing the class default level will assign the new default to any existing students who have not yet engaged in activities and those who join or are invited to this class in the future. Students in this class who are already engaged will not be affected, and their level might be different than the default. If necessary, you may change existing students’ current level individually or in bulk.',
            defaultLevelChangedExistingClass:
              'This default level will apply to any students who haven’t engaged in activities yet and to any who join this class in the future. Engaged students will not be affected.',
            defaultLevelChangedNewClass:
              'This default level will apply to all students in the class.',
            placementTestTurnedOff:
              'Turning off the level test will assign the class default level to any students who haven’t engaged with any activities yet or who join this class in the future. Students in this class who are already active will not be affected, and their level might be different than the default.',
            placementTestTurnedOffExistingClass:
              'Turning off the level test will assign the class default level to any students who haven’t engaged with any activities yet or who join this class in the future. Engaged students will not be affected.',
            placementTestTurnedOffNewClass:
              'Turning off the level test means all students will be assigned the class default level.',
            placementTestTurnedOn:
              'Turning on the level test will remove the class default level from any students who haven’t engaged with any activities yet. They, and any students who join this class in the future, will need to complete the level test first. Students in this class who are already active will not be affected.',
            placementTestTurnedOnExistingClass:
              'Turning on the level test will remove the class default level from any students who haven’t engaged with any activities yet. They, and any students who join this class in the future, will need to complete the level test first. Engaged students will not be affected.',
            placementTestTurnedOnNewClass:
              'Turning on the level test means all students will need to complete it before starting to engage in activities.',
          },
        },
        newClass: 'Adicionar turma',
        placeholderWriteHere: 'Escreva aqui',
        saveClassAndAddLater: 'Salvar e adicionar alunos mais tarde',
        searchPlaceholder: 'Pesquisar turmas',
        teachersLabel: 'Professores (até 2)',
        teachersPlaceholder: 'Selecionar',
        teachersSearchPlaceholder: 'Pesquisar professor',
        title: 'Turmas',
        viewClassPage: {
          addStudents: 'Adicionar alunos',
          classCodeLabel: 'Código de turma',
          coTeacher: 'Professor colaborador',
          editClass: 'Editar turma',
          metaActiveLabel: 'Ativo(s)',
          metaInactiveLabel: 'Inativo(s)',
          metaStudentsLabel: 'Alunos',
          studentColumnName: 'Nome e status',
          teacher: 'Professor',
        },
        viewClasses: 'Ver turmas',
        zeroState: {
          buttonText: 'Adicionar turma',
          description:
            'Crie uma turma, adicione alunos e convide-os a iniciar suas jornadas de aprendizagem em inglês.',
          filterDescription: 'Tente ajustar ou redefinir os filtros para visualizar os dados.',
          filterTitle: 'Sem dados disponíveis relativos aos filtros selecionados.',
          title: 'Crie sua primeira turma!',
        },
      },
      editSchool: 'Editar',
      general: {
        country: 'País',
        expirationDate: 'Data de expiração',
        licensesUsage: 'Licenças usadas',
        sharedLicenseHint:
          '*O número total de licenças é compartilhado entre várias escolas sob o mesmo contrato. O número de licenças disponíveis pode variar de acordo com o uso por outras escolas.',
        title: 'Informações da escola',
        totalClasses: 'Número total de turmas',
        totalStudents: 'Número total de alunos',
        totalTeachers: 'Número total de professores',
      },
      loadingSchoolDetails: 'Carregando detalhes da escola...',
      newClassForm: {
        classNamePlaceholder: 'Escreva aqui',
      },
      notFound: 'Escola não encontrada.',
      students: {
        allLevels: 'Todos os níveis',
        allLevelsHint: 'Os dados refletem o desempenho dos alunos em todos os níveis.',
        changeLevel_one: 'Change Level',
        changeLevel_other: 'Change Level',
        currentLevel: 'Nível atual',
        deleteStudents_one: 'Excluir aluno',
        deleteStudents_other: 'Excluir alunos',
        displayDataFor: 'Exibir dados de',
        errorLoading: 'Erro ao carregar os alunos: {{error}}',
        failedToFetch: 'Não foi possível localizar os alunos',
        moveStudents_one: 'Transferir aluno',
        moveStudents_other: 'Transferir alunos',
        searchPlaceholder: 'Pesquisar alunos',
        subTitle: '*O nível inicial foi alterado.',
        title: 'Alunos',
        titleOnSelected_one: '1 de {{maxNum}} registros selecionados',
        titleOnSelected_other: '{{num}} de {{maxNum}} registros selecionados',
        zeroState: {
          description:
            'Ao adicionar alunos, você poderá gerenciá-los e acessar suas informações em um lugar só.',
          filterDescription: 'Tente ajustar ou redefinir os filtros para visualizar os dados.',
          filterTitle: 'Sem dados relativos aos filtros selecionados',
          title: 'Ainda não há alunos matriculados na turma!',
        },
      },
      teachers: {
        addManually: 'Fazer upload de arquivo / Adicionar manualmente',
        copyLink: 'Copiar link',
        errorLoading: 'Erro ao carregar os professores: {{error}}',
        failedToCreate: 'Não foi possível criar o professor',
        failedToFetch: 'Não foi possível localizar os professores',
        filters: {
          teachers: 'Nome do professor',
          teachersSearchPlaceholder: 'Nome e sobrenome',
        },
        inviteLinkDescription:
          'Copie e compartilhe o link a seguir para convidar os professores a fazer login.',
        inviteYourTeachers: 'Convidar professores',
        linkCopied: 'Link copiado!',
        linkCopiedMessage: 'Agora você pode compartilhar o link com os professores.',
        newTeacher: 'Adicionar professor',
        searchPlaceholder: 'Pesquisar professores',
        title: 'Professores',
        zeroState: {
          description:
            'Adicione os professores para que eles possam criar turmas e adicionar alunos.',
          filterDescription: 'Tente ajustar ou redefinir os filtros para visualizar os dados.',
          filterTitle: 'Sem dados relativos aos filtros selecionados.',
          title: 'Cadastre os professores!',
        },
      },
    },
    schoolsListPage: {
      allLevelsHint: 'Os dados refletem o desempenho dos alunos em todos os níveis.',
      classCreated: 'A turma foi criada com sucesso!',
      columns: {
        activeUsers: 'Usuários ativos',
        registeredUsers: 'Usuários registrados',
        schoolAdmin: 'Gestor escolar',
        schoolAdminEmail: 'E-mail do gestor escolar',
        schoolName: 'Nome e tipo de escola',
        status: 'Status',
      },
      createNewSchool: '+ Criar nova escola',
      filters: {
        adminEmail: 'E-mail do gestor escolar',
        schoolAdmin: 'Gestor escolar',
        schoolType: 'Tipo de escola',
      },
      newSchool: 'Nova escola',
      studentCreatedSuccessfully: 'Perfil de aluno criado com sucesso!',
      studentsCreatedInClass: 'Perfis de alunos criados com sucesso na turma {{className}}!',
      title: 'Escolas',
    },
    schoolsTable: {
      addNew: '+ Adicionar nova escola',
      columns: {
        contact: 'Contato',
        school: 'Escola',
        students: 'Alunos',
        teachers: 'Número de professores',
      },
      noResults: 'Não há escolas criadas neste contrato.',
    },
    settings: {
      about: 'Sobre',
      about_me: {
        my_account: 'Minha escola',
        my_language: 'Minha língua nativa',
        my_name: 'Meu nome',
        title: 'Sobre mim',
      },
      account_settings: 'Configurações da conta',
      add_students: {
        add_student: 'Adicionar aluno',
        classCreatedDescription:
          'Seus alunos receberam instruções por e-mail para redefinir suas senhas. Após o login, eles farão um teste de nivelamento. Com base nos resultados, serão alocados no nível apropriado e poderão iniciar suas jornadas de aprendizagem.',
        classCreatedDescriptionNoLevelTest:
          'Your students have been emailed instructions for resetting their password. Once your students log in, they will be placed at the default level and may begin their learning journey.',
        create_students: 'Os alunos a seguir receberão um e-mail de convite:',
        enroll_students: 'Adicionar alunos',
        enrollment_unsuccessful_description_validation:
          'Os alunos listados a seguir não puderam se matricular por erros de validação:',
        errors: {
          file_empty: 'O arquivo que você está tentando carregar está vazio.',
          first_name_incorrect: 'Nome inválido. Nome contém caracteres inválidos ou é muito longo.',
          last_name_incorrect:
            'Sobrenome inválido. Sobrenome contém caracteres inválidos ou é muito longo.',
          wrong_format:
            'O formato do arquivo é inválido. Certifique-se de que esteja enviando um arquivo Excel (xlsx).',
        },
        partial_success_description:
          '{{addedStudents}} de {{totalStudents}} alunos foram matriculados com sucesso nessa turma.<br/>Foi-lhes enviado um e-mail com suas senhas temporárias. ',
        student_creation_error: 'Falha ao criar perfil de aluno. Tente novamente.',
        studentsSuccessfullyEnrolled: 'Os alunos foram inscritos com sucesso.',
        upload_file: 'Faça o upload do arquivo Excel dos alunos.',
      },
      add_teachers: {
        add_teacher: 'Adicionar professor',
        add_teachers_manually: 'Adicionar manualmente',
        button_next: 'Próximo',
        click_to_browse: 'clique para pesquisar',
        create_teacher: 'Criar perfil de professor',
        create_teachers: 'Os professores a seguir receberão um e-mail de convite:',
        download: 'Fazer download',
        download_sample: 'de um modelo de arquivo de Excel (xlsx)  ',
        drag_here: 'Arraste um arquivo para cá ou ',
        enroll_teachers: 'Adicionar professores',
        enrollment_unsuccessful: '⚠️ Inclusão de professor não concluída!',
        enrollment_unsuccessful_description:
          'Os professores listados a seguir não puderam ser adicionados pois seus e-mails já foram utilizados:',
        enrollment_unsuccessful_description_validation:
          'Os professores listados a seguir não puderam ser adicionados por erros de validação:',
        errors: {
          bad_formatting:
            'Seu arquivo não está formatado corretamente. <br/>Verifique seus dados e faça as correções necessárias',
          email_in_use: 'Este e-mail já está registrado.',
          email_incorrect: 'Insira um e-mail válido.',
          file_empty: 'O arquivo que você está tentando carregar está vazio.',
          file_too_large: 'O arquivo é muito grande. O tamanho máximo permitido é 256KB.',
          first_name_incorrect: 'Nome inválido. Nome contém caracteres inválidos ou é muito longo.',
          first_name_missing: 'O preenchimento do nome é obrigatório.',
          first_name_too_long: 'O nome pode ter até 30 caracteres.',
          last_name_incorrect:
            'Sobrenome inválido. O sobrenome contém caracteres inválidos ou é muito longo.',
          last_name_missing: 'O preenchimento do sobrenome é obrigatório.',
          last_name_too_long: 'O sobrenome pode ter até 40 caracteres.',
          limit_reached:
            'O número máximo de professores é 50. <br/>Exclua o arquivo e faça o upload de um novo.',
          limit_reached_description: 'Sua turma contém o número máximo permitido de professores.',
          limit_reached_title: 'Esta turma está lotada.',
          max_number_of_teachers:
            'O número máximo de professores é 50. <br/>Exclua o arquivo e faça o upload de um novo.',
          teachers_not_registered: 'Alguns professores não foram registrados',
          username_invalid: 'O nome de usuário já existe',
          username_missing: 'O nome de usuário é obrigatório.',
          wrong_format:
            'O formato do arquivo é inválido. Certifique-se de que esteja enviando um arquivo Excel (xlsx).',
        },
        invite_teachers: 'Convidar professores',
        not_enough_licenses:
          'Not enough licenses available to complete this operation. {{available}} licenses available, but {{requested}} teachers were requested.',
        partial_success: '⚠️ Sucesso parcial',
        partial_success_description:
          '{{addedTeachers}} de {{totalTeachers}} professores foram adicionados com sucesso.<br/>Foi-lhes enviado um e-mail com suas senhas temporárias.',
        register_your_teachers: 'Inscreva os professores',
        success_description:
          'Foi enviado um e-mail aos professores com instruções para redefinição de senha.<br/>Depois dessa etapa, eles poderão começar a usar o Hello Britannica.',
        teacherCreationError: 'Falha ao criar perfil do professor. Tente novamente.',
        teacher_creation_error: 'Falha ao criar perfil do professor. Tente novamente.',
        teachers_added: 'Os professores foram adicionados com sucesso!',
        upload_attention_text:
          '⚠️ Sua organização contém {{curent}}/{{limit}} professores. <br/>Você pode adicionar mais {{certified}} professores.',
        upload_attention_text_new_class: '⚠️ Max. {{limit}} de professores',
        upload_file: 'Faça o upload do arquivo Excel dos professores.',
        upload_successful: 'O upload do arquivo foi realizado com sucesso.',
      },
      delete_class: {
        classNotEmpty: 'Você não pode excluir uma turma que contenha alunos.',
        classNotEmptyDescription:
          'Caso deseje excluir essa turma, você deve primeiro excluir os alunos. Você pode fazê-lo abrindo o perfil do aluno e clicando no ícone "Editar".',
      },
      delete_student: {
        tryAgain: 'Tente novamente',
      },
      language_of_study: 'Idioma de estudo',
      native_language: 'Minha língua nativa',
      passwordRequirements: {
        atLeastOneLowercase: 'Contém ao menos 1 letra minúscula',
        atLeastOneNumber: 'Contém ao menos 1 número',
        atLeastOneSpecial: 'Contém ao menos 1 caractere especial',
        atLeastOneUppercase: 'Contém ao menos 1 letra maiúscula',
        passwordMinimumLength: 'Tamanho mínimo de 8 caracteres',
      },
      preferences: 'Preferências',
      school_id: 'Minha escola',
      suggested_languages: 'Idiomas sugeridos',
    },
    statesListPage: {
      welcomeMessage:
        'Esta plataforma permite criar e gerenciar o status das atividades da plataforma <strong>Hello Britannica English Learning</strong>. Siga em frente e crie seu primeiro status!',
      welcomeTitle: 'Bem-vindo, administrador!',
    },
    statsCardGroup: {
      averageSessionTime: '📊 Média de tempo gasto',
      averageSessionTimeEmpty: 'Os alunos ainda não iniciaram as atividades',
      averageSessionTimeTooltip: 'Média de tempo gasto pelos alunos durante as atividades',
      engagedStudents: '🟢 Alunos engajados',
      engagedStudentsEmpty: 'Os alunos ainda não concluíram nenhuma atividade',
      engagedStudentsTooltip: 'Alunos que já iniciaram ao menos uma atividade',
      engagedTeachers: '🟢 Professores engajados',
      engagedTeachersEmpty: 'Os professores ainda não criaram turmas',
      engagedTeachersTooltip: 'Professores que possuem ao menos uma turma',
      passiveStudents: '🟢 Alunos passivos',
      passiveStudentsEmpty: 'Ainda não há alunos matriculados na turma',
      passiveStudentsTooltip: 'Alunos que ainda não iniciaram nenhuma atividade',
      totalTimeSpent: 'Tempo total gasto',
      totalTimeSpentEmpty: 'Os alunos ainda não iniciaram as atividades',
      totalTimeSpentTooltip: 'Tempo total gasto pelos alunos nas atividades',
    },
    studentDataModal: {
      activities: 'Atividades',
      completedLevelNotice:
        "Student has no more new activities. You may manually advance their level if your school's curriculum allows.",
      days: {
        friday: 'Sex',
        monday: 'Seg',
        saturday: 'Sáb',
        sunday: 'Dom',
        thursday: 'Qui',
        tuesday: 'Ter',
        wednesday: 'Qua',
      },
      deleteStudentForm: {
        areYouSure: 'Tem certeza?',
        cancel: 'Cancelar',
        choose: 'Selecionar',
        close: 'Fechar',
        delete: 'Excluir',
        deletingFailed: 'Falha ao excluir.',
        deletingFailedDescription:
          'Nossos servidores não estão respondendo. Tente novamente. Caso o problema persista, entre em contato conosco em <a href="mailto:{{email}}">{{email}}</a>',
        description:
          'Excluir este aluno o removerá permanentemente da plataforma. Ele não poderá mais fazer login e todos os seus dados de progresso serão perdidos. Para isso, por gentileza, forneça um motivo:',
        oops: 'Ops!',
        reason: 'Motivo',
        reasons: {
          aClericalError: 'Erro administrativo',
          other: 'Outro',
          requestedToBeRemoved: 'O aluno ou o responsável solicitou sua exclusão',
        },
        tryAgain: 'Tente novamente',
        why: 'Por quê?',
      },
      editForm: {
        ChooseAnotherLevel: 'Selecionar outro nível',
        areYouSure: 'Tem certeza?',
        cancel: 'Cancelar',
        changingLevel: 'Alterar o nível do aluno excluirá seu progresso e histórico!',
        currentLevel: 'Nível atual',
        deleteStudent: 'Excluir aluno',
        edit: 'Editar',
        email: 'E-mail',
        errors: {
          anErrorOccurred: 'Ocorreu um erro',
          email_incorrect: 'Insira um e-mail válido.',
          first_name_incorrect: 'Nome inválido. Nome contém caracteres inválidos ou é muito longo.',
          first_name_missing: 'O preenchimento do nome é obrigatório.',
          first_name_too_long: 'O nome pode ter até 30 caracteres.',
          last_name_incorrect:
            'Sobrenome inválido. Sobrenome contém caracteres inválidos ou é muito longo.',
          last_name_missing: 'O preenchimento do sobrenome é obrigatório.',
          last_name_too_long: 'O sobrenome pode ter até 40 caracteres.',
        },
        firstname: 'Nome',
        interfaceLanguage: 'Idioma da interface',
        language: 'Idioma',
        lastname: 'Sobrenome',
        level: 'Nível',
        save: 'Salvar',
        userDataSuccessfullyUpdated:
          'As informações foram atualizadas com sucesso. Peça ao aluno para sair da plataforma e refazer o login para visualizar as alterações feitas.',
        username: 'Nome de usuário',
        yes: 'Sim',
      },
      firstLogin: 'Primeiro login',
      interfaceLanguage: 'Idioma da interface',
      level: 'Nível',
      progress: 'Progresso',
      report: {
        activitiesCompletedInLevel: 'Atividades concluídas no nível {{level}}',
        allLevelsAvgTime: '📊 Tempo médio de todos os níveis',
        attemptsAndHints: 'Tentativas e dicas',
        avgAttemptsPerActivity: 'Média por atividade',
        avgHintsPerActivity: 'Média de dicas por atividade',
        avgPerWeek: 'Média geral por semana',
        avgProgress: 'Progresso médio',
        avgSkillScores: 'Pontuação nas habilidades',
        avgStreakPerWeek: 'Média geral de frequência por semana',
        classDataNotAvailable: 'Os dados dessa turma não estão disponíveis. ',
        continuousEngagement: 'Empenho contínuo',
        date: 'Data',
        engagement: 'Empenho',
        failureRate: 'Índice de reprovação',
        generateReport: 'Relatório geral',
        inCurrentLevel: 'No nível atual',
        level: 'Nível',
        longestStreak: 'Maior frequência',
        overallProgressInLevel: 'Progresso geral no nível {{level}}',
        passRate: 'Índice geral de aprovação',
        previous7Days: 'Últimos 7 dias',
        progress: 'Progresso',
        skippedActivitiesComment:
          '* Atividades não concluídas são incluídas no total de atividades',
        streakLast7Days: 'Frequência nos últimos 7 dias',
        streakLength: 'Frequência individual total',
        studentName: 'Nome do aluno',
        studentReport: 'Relatório do aluno',
        timeSpentOnActivites: 'Tempo gasto nas atividades',
        total: 'Total',
        totalHintsUsed: 'Total de dicas usadas',
        totalInPrev7Days: 'Total nos últimos 7 dias',
        tryAgainLater: 'Tente novamente mais tarde!',
        weCouldNotProduce: 'O relatório não pode ser gerado no momento.',
        weStillDontHaveAll: 'Nós ainda não temos todas as informações necessárias.',
      },
      schoolName: 'Nome da escola',
      selfPracticeStreak: 'Frequência de prática do aluno',
      thisStudentIsInactive:
        'Este aluno está inativo. Ele foi convidado para a turma, mas ainda não realizou o teste de nivelamento.',
      thisStudentIsLevelTestIncomplete:
        'Este aluno ainda não concluiu o teste de nivelamento. Após concluí-lo, você poderá acompanhar o seu progresso.',
      topics: 'Tópicos',
      totalProgressWithinLevel: 'Progresso total dentro do nível',
      unitData: {
        activities: 'Atividades',
        canDo: 'Competência(s)',
        completed: 'Concluído',
        failed: 'Reprovado',
        level: 'Nível',
        skipped: 'Não concluída(s)',
        somethingWentWrong: 'Ocorreu um erro. Tente novamente mais tarde',
        stars: 'Estrelas',
        toggle: 'Alternar',
        topics: 'Tópicos',
        totalActivities: 'Total de atividades',
      },
      viewPerformance: 'Ver desempenho',
    },
    studentMetricsDashboard: {
      charts: {
        avgStudentGrowth: {
          averageGrowth: 'Crescimento médio',
          month: 'Mês',
        },
        kpis: {
          averageTimeSpent: {
            tooltip: 'Tempo médio gasto pelo alunos em atividades',
          },
          passRate: {
            tooltip: 'Porcentagem de aprovações nas atividades.',
          },
          totalTimeSpent: {
            tooltip: 'Tempo total gasto pelos alunos em jogos',
          },
        },
        studentsAcrossSkills: {
          tooltipStudents: 'alunos',
        },
      },
      drillDown: {
        students: {
          columns: {
            classNameAndGrade: 'Turma e ano/série',
            coTeacherName: 'Nome do professor colaborador',
            nameAndCoTeacher: 'Nome e professor colaborador',
            nameAndTeacher: 'Nome e professor',
          },
        },
      },
      emptyState: {
        filter: {
          description: 'Tente ajustar ou redefinir os filtros para visualizar os dados.',
          title: 'Sem dados relativos aos filtros selecionados.',
        },
        noStudents: {
          description:
            'Depois de adicionar os alunos, você poderá gerenciá-los e visualizar suas informações aqui.',
          title: 'Nenhum aluno adicionado ainda!',
        },
      },
      filters: {
        coTeacher: 'Nome do professor colaborador',
        fail: 'Reprovação',
        pass: 'Aprovação',
        score: 'Pontuação',
        status: 'Status',
        statusSearchPlaceholder: 'Pesquisar status',
      },
      totalStudents: 'Alunos engajados: {{totalStudents}}',
    },
    tabbedCard: {
      addNew: '+ Adicionar novo',
      tabs: {
        districts: 'Unidades/municípios',
        schools: 'Escolas',
      },
    },
    topic: 'Tópico',
    university: 'Ensino Superior',
    validation: {
      mustBeAtLeastCharacters: 'Este campo deve conter no mínimo {{length}} caracteres',
    },
  },
  adminInstructions: 'Instruções para o gestor escolar',
  again: 'novamente',
  all: 'Todos',
  allDone: 'Concluído!',
  allLevels: 'Todos os níveis',
  almostFinish: 'Quase lá!',
  almostMadeIt: 'Quase conseguiu',
  almostThere: 'Você está quase lá...',
  amazing_job: 'Ótimo trabalho!',
  anErrorOccurred: 'Ocorreu um erro',
  andInviteYourStudents: 'e convide seus alunos',
  andThenInvite: 'e depois convide seus alunos para participarem dela',
  answerNotAccepted: 'Resposta não aceita',
  answeredIncorrectly: 'respondeu incorretamente.',
  appName: 'Hello Britannica',
  appTitle: 'Britannica',
  areYouReadyForTheQuiz: 'Você acha que está pronto para jogar?',
  areYouSure: 'Tem certeza?',
  asSoonAsTheyStart: 'Assim que o aluno alterar sua senha temporária, ele se tornará ativo',
  asSoonAsTheyStartGoogle:
    'Sua turma foi criada e agora você precisa adicionar seus alunos! <br/>Use o botão Sincronizar para importar os alunos da turma do Google Sala de Aula para a plataforma do Hello.',
  assessment: 'Avaliação',
  assessments: 'Avaliações',
  atLeastOneLowercase: 'Contém pelo menos 1 letra minúscula',
  atLeastOneNumber: 'Contém pelo menos 1 número',
  atLeastOneSpecial: 'Contém pelo menos 1 caractere especial',
  atLeastOneUppercase: 'Contém pelo menos 1 letra maiúscula',
  avgAttempts: 'Tentativas',
  avgCurrentLevel: 'Nível médio atual',
  avgCurrentLevelTooltip: 'Nível atual médio dos alunos.',
  avgCurrentLevel_mobile: 'Nível médio atual',
  avgFailureRate: '❌Índice geral de reprovação',
  avgLevel_mobile: 'Nível médio',
  avgPassRate: '✅ Índice geral de aprovação',
  avgProgress: 'Progresso médio',
  avgProgressTooltip: 'Progresso médio dos alunos em seu nível atual',
  avgProgress_mobile: 'Progresso médio',
  avgScore: 'Pontuação média',
  avgScoreTooltip: 'A pontuação média dos alunos em todas as atividades do seu nível atual',
  avgScore_mobile: 'Pontuação média',
  avgTimeSpent: 'Tempo gasto',
  avgTimeSpentTooltip: 'Média do tempo total gasto pelos alunos nos jogos.',
  avgTimeSpent_mobile: 'Tempo gasto',
  back: 'Voltar',
  backHome: 'Voltar à página inicial',
  backOnline: 'Parece que você está online novamente!',
  backOnlineActivities: 'Vamos retomar as atividades não concluídas.',
  bimloaFilter: {
    all: 'Todos',
    close: 'Fechar',
    filter: 'Filtrar',
    filterBy: 'Filtros',
    max: 'Máx.',
    min: 'Mín.',
    reset: 'Redefinir',
    resetAll: 'Redefinir tudo',
    to: 'para',
  },
  britannicaEducationWith: 'Britannica Education com',
  byClickingOn:
    'Ao clicar no nome do aluno, você verá o desempenho dele em cada habilidade e com que frequência utiliza o aplicativo. Você também pode decidir qual idioma de interface ele deve usar.',
  cameraPermission: {
    button: 'Tentar novamente',
    text: 'Permissão de câmera negada. Habilite o acesso à câmera nas configurações do seu navegador.',
  },
  canDo: 'Competência(s)',
  cancel: 'Cancelar',
  change_password: 'Alterar senha',
  changingLevel: 'Alterar o nível do aluno excluirá seu progresso e histórico!',
  characters: 'Caracteres ',
  checkInSpamMessage: 'Não recebeu? Verifique sua <0>caixa de spam</0>.',
  choose: 'Selecionar',
  chooseAvatar: 'Selecionar avatar',
  chooseGrade: 'Selecionar ano/série',
  chooseTheCorrectAnswer: 'Selecione a resposta correta para completar a frase:',
  chooseUsername: 'Escolha o nome de usuário',
  chooseYourClasses: 'Selecione as turmas que você deseja importar do Google Sala de Aula',
  chooseYourFavoriteAvatar: 'Selecione seu avatar e cor favoritos',
  city: 'Cidade ou município',
  class: 'Turma',
  classCode: 'Código de turma',
  classCodeClassLimitReached: 'Limite de inscrição em turma atingido',
  classCodeDealInvalidCode:
    'Código inválido. Verifique sua inscrição ou entre em contato com seu professor para obter um novo código de turma.',
  classCodeDealLimitReached: 'Limite de acessos por escola atingido',
  classCodeDealNotActive: 'O link que você está tentando acessar expirou',
  classCodeDealNotValid:
    'O código de turma informado expirou. Verifique sua inscrição ou entre em contato com seu professor para obter um novo código de turma.',
  classCodeNotActive:
    'O código da turma não está ativo. Verifique sua inscrição ou entre em contato com seu professor para obter um novo código de turma.',
  classCreated: 'A turma foi criada com sucesso!',
  className: 'Nome da turma',
  classReport: 'Relatório da turma',
  classWasDeleted: 'Parece que a turma “{{className}}” foi excluída do Google Sala de Aula',
  classWasDeletedDescription:
    'você não pode executar essa ação até que a turma excluída seja removida.',
  classes: 'Turmas',
  classesDeleted: 'A turma foi excluída com sucesso!',
  classesDeletedDescription: 'Você não terá mais a opção de visualizar ou editar essa turma',
  classesImported: 'Suas turmas foram importadas!',
  clickHere: 'Clique aqui!',
  close: 'Fechar',
  closeMenu: 'Fechar menu',
  coTeacher: 'Professor colaborador',
  cognitoErrors: {
    CodeMismatchException: 'Código de verificação inválido. Tente novamente.',
    ExpiredCodeException: 'O código fornecido é inválido. Solicite novamente um código.',
    LimitExceededException: 'Limite de tentativas excedido. Tente novamente mais tarde.',
    NetworkError: 'Erro de rede. Verifique sua conexão com a internet e tente novamente.',
    NewPasswordRequiredSessionExpired: 'A sessão expirou. Volte e tente novamente.',
    NotAuthorizedException: 'E-mail ou senha inválidos',
    UserNotConfirmedException:
      'Sua conta não é verificada. Insira o código de verificação enviado ao seu e-mail.',
    UsernameExistsException: 'Nome de usuário já existe',
  },
  coins: 'Moedas',
  coinsInstructions: 'Você pode usá-las para obter ajuda enquanto joga.',
  coinsWillBeLost: 'e todas as moedas que você ganhou serão perdidas',
  comingSoon: 'Em<br/>breve',
  complete: 'Completo',
  completeImportError:
    'Suas turmas não puderam ser importadas porque já foram importadas por outro professor.',
  completed: 'Concluído',
  completedActivities: 'Total de atividades concluídas neste nível',
  completedLevelNotice:
    "Student has no more new activities. You may manually advance their level if your school's curriculum allows.",
  confirmPassword: 'Confirmar senha',
  contactAdmin: 'Entre em contato com o gestor escolar para obter ajuda.',
  contactOurTeam: 'Em caso de dúvidas, entre em',
  contactOurTeamWithQuestions:
    'Entre em contato com nossa equipe em caso de dúvidas ou outros assuntos.',
  contactTeacher: 'Entre em contato com seu professor para obter uma senha temporária!',
  contactUs: 'Fale conosco',
  contactUsSubtitle: 'Nossa equipe lhe fornecerá respostas e orientações.',
  continue: 'Continuar',
  continueOnWeb: 'Continuar na web',
  continueQuiz: 'Continuar o jogo',
  continueToQuestions: 'Continuar em perguntas',
  continue_level_test: 'Continuar teste de nivelamento',
  copy: 'Copiar',
  copyInvitationLink: 'Copiar link do convite',
  copyLink: 'Copiar link',
  copyTemporaryPassword: 'Copiar senha',
  copyTemporaryPasswordDescription:
    'Você pode copiar a senha e enviá-la para {{firstName}}{{lastname}}!',
  copyright: '2026 Encyclopedia Britannica, Inc.',
  couldNotLocate: 'Não foi possível localizar a página que você procura.',
  country: 'País',
  create: 'Criar',
  createClass: 'Adicionar turma',
  createClassCode: 'Criar código de turma',
  createNewClass: 'Adicionar turma',
  createYourClass: 'Criar turma e convidar os alunos',
  createYourFirstClass: 'Crie sua primeira turma',
  createYourFirstClassDescription:
    'Configure a turma e, em seguida, faça upload da lista de alunos que você gostaria de matricular nesta turma. Depois convide os alunos para participar.',
  currentLevel: 'Nível atual',
  current_password: 'Senha atual',
  customYourLearning: 'Em breve, poderemos personalizar sua experiência de aprendizagem!',
  dashboard: 'Painel de controle',
  date: 'Data',
  dealLimitReachedMessageAdminDescription:
    'Não é possível adicionar mais alunos. Entre em contato conosco para obter ajuda.',
  dealLimitReachedMessageAdminTitle: 'O limite de licenças da sua escola foi atingido.',
  dealLimitReachedMessageDescription:
    'Não é possível adicionar mais alunos. Entre em contato com o gestor escolar para obter orientações.',
  dealLimitReachedMessageTitle: 'O limite de usuários da sua escola foi atingido.',
  dearSchoolAdmin: 'Caro administrador da escola, o senhor foi',
  dearTeacher: 'Caro professor, você foi convidado a participar de',
  delete: 'Excluir',
  deleteClass: 'Excluir turma',
  deleteClasses: 'Excluir turmas',
  deleteClassesAttention:
    'Observe que, em caso de exclusão da turma, todos os dados serão removidos e não poderão ser restaurados. O progresso de todos os alunos será excluído.',
  deleteClassesDescription:
    'Observe que, em caso de exclusão da turma, todos os dados serão removidos e não poderão ser restaurados. O progresso de todos os alunos será excluído.',
  dictionary: 'Dicionário',
  didntQuiteHearThat: 'Não ouvi bem.',
  doYouHaveAClassCode: 'Você tem um código de turma?',
  doingGreat: 'Você está indo muito bem!',
  done: 'Concluído',
  dontKnow: 'Não sei',
  downloadAndView: 'Fazer download e visualizar',
  downloadClassReport: 'Baixar relatório da turma',
  downloadList: 'Lista de downloads',
  edit: 'Editar',
  editClass: 'Editar turma',
  editClassClassNameAlreadyExists: 'Já existe uma turma com esse nome',
  editClassInvalidClassName: 'Nome da turma é obrigatório',
  editClassInvalidClassNameFormat: 'Class name contains invalid characters.',
  editClassInvalidGrade: 'Ano/série é obrigatório',
  editClassInviteNewStudent: 'Adicionar novos alunos',
  editClassStudentFullClassDescription: 'Sua turma possui o número máximo<br/>de alunos permitido.',
  editClassStudentFullClassTitle: 'Essa turma está lotada.',
  editClassStudentNewStudentAddedDescription:
    'Foi enviado aos alunos um e-mail com instruções sobre como redefinir a senha. Depois de fazer login na plataforma, eles receberão um teste de nivelamento e serão designados para o nível apropriado. A partir daí, poderão iniciar sua jornada de aprendizagem.',
  editClassStudentNewStudentAddedTitle: 'foi convidado!',
  editClassStudentStatus: 'Status',
  editClassStudentStatusActive: 'Ativo',
  editClassStudentStatusInactive: 'Inativo',
  email: 'E-mail',
  emailExample: 'exemplo@gmail.com',
  emailOrUsername: 'E-mail ou nome de usuário',
  emailVerification: 'Verificação de e-mail',
  englishLearningJourney: 'jornada de aprendizagem de inglês com o Hello Britannica.',
  englishLearningJourneyMorfix: 'Jornada de aprendizagem de inglês com o Morfixschool 2.0.',
  englishSkillsAssessments: 'Avaliações das habilidades em inglês',
  enterCodeHere: 'Digite o código aqui',
  enterNewPassword: 'Insira a nova senha',
  enterVerificationCode: 'Digite o código de verificação',
  enterVerificationCodeAndNewPassword: 'Digite o código de verificação e a nova senha',
  enterVerificationCodeHelpText: 'Insira o código fornecido pela instituição de ensino.',
  enterYourAnswerHere: 'Digite sua resposta aqui',
  error: {
    apiMessages: {
      accessDenied: 'Access denied.',
      accessDeniedOrStudentNotFound: 'Access denied or the student is not found.',
      accessDeniedOwnSchoolOnly: 'Access denied - you can only access data from your own school.',
      atLeastOneNameRequired: 'At least one field (first name or last name) must be provided.',
      atLeastOneTeacherRequired: 'At least one teacher must be assigned to the class.',
      atLeastOneUserRequired: 'At least one user is required.',
      classCodeRequired: 'Class code is required.',
      classCodeValidationFailed: 'Failed to process the class code validation response.',
      classReportNotFound: 'Class report not found.',
      dealNotFound: 'Deal not found.',
      dealNotFoundOrInvalid: 'Deal not found or is invalid.',
      dealValidationFailed: 'Deal validation failed.',
      errorCheckingTeacherDeletionEligibility:
        'An error occurred while checking teacher deletion eligibility. Please, try again later.',
      errorCreatingDeal:
        'An error occurred while creating or updating the deal. Please, try again later.',
      errorCreatingGroup: 'An error occurred while creating the group. Please, try again later.',
      errorCreatingPrincipalAdmin:
        'An error occurred while creating the principal admin. Please, try again later.',
      errorDeletingUser: 'An error occurred while deleting the user. Please, try again later.',
      errorProcessingDeletionRequest:
        'An error occurred while processing the deletion request. Please, try again later.',
      errorProcessingTeacherDeletionActions:
        'An error occurred while processing teacher deletion. Please, try again later.',
      errorSigningOut: 'An error occurred while signing out. Please, try again later.',
      errorValidatingClassCode:
        'An error occurred while validating the class code. Please, try again later.',
      errorValidatingDeal: 'An error occurred while validating the deal. Please, try again later.',
      failedToCreateAccount: 'Failed to create the account. Please, try again later.',
      failedToCreateComprehensiveAccount: 'Failed to create the account. Please, try again later.',
      failedToCreateGroup: 'Failed to create a group. Please, try again later.',
      failedToCreateRegion: 'Failed to create region. Please, try again later.',
      failedToCreateStudent: 'Failed to create student. Please, try again later.',
      failedToDeleteGradeConfiguration:
        'Failed to delete grade configuration. Please, try again later.',
      failedToDeleteTeacher: 'Failed to delete teacher. Please, try again later.',
      failedToDeleteTeacherWithActions:
        'Failed to process teacher deletion. Please, try again later.',
      failedToDeleteUser: 'Failed to delete user. Please, try again later.',
      failedToGenerateAdminGuideUrl:
        'Failed to generate the admin guide URL. Please, try again later.',
      failedToProcessUserCreation:
        'Failed to process the user creation request. Please, try again later.',
      failedToRegisterDevice: 'Failed to register the device. Please, try again later.',
      failedToRetrieveDealList: 'Failed to retrieve the deal list.',
      failedToRetrieveRegions: 'Failed to retrieve regions.',
      failedToRetrieveStudentMetrics: 'Failed to retrieve student metrics.',
      failedToRetrieveStudentSkillPerformance: 'Failed to retrieve student skill performance data.',
      failedToRetrieveUserList: 'Failed to retrieve the user list.',
      failedToRetrieveUserStatistics: 'Failed to retrieve user statistics.',
      failedToSaveGradeConfiguration:
        'Failed to save grade configuration. Please, try again later.',
      failedToSetInterfaceLanguage:
        'Failed to set the interface language. Please, try again later.',
      failedToSetStudentSettings: 'Failed to set student settings. Please, try again later.',
      failedToSetUserAvatar: 'Failed to set the user avatar. Please, try again later.',
      failedToSignOut: 'Failed to sign out. Please, try again later.',
      failedToUpdateActivities: 'Failed to update user activities.',
      failedToUpdateGroup: 'Failed to update group. Please, try again later.',
      failedToUpdateTeacher: 'Failed to update teacher. Please, try again later.',
      forbidden: 'Action forbidden.',
      googleUserNotFound: 'Google user not found.',
      gradeConfigurationNotFound: 'Grade configuration not found.',
      groupDeletionFailed: 'Group deletion failed. Please, try again later.',
      groupNotFound: 'Group not found.',
      groupsNotFound: 'Groups not found.',
      groupsReportNotFound: 'Groups report not found.',
      groupsReportTimedOut:
        'The request timed out while retrieving the groups report. Please, try again later.',
      incompleteResponseData: 'The response was successful, but the data was incomplete.',
      incompleteStudentCreationResponse:
        'The response was successful, but the data was incomplete. Students may have been created – please refresh and verify.',
      internalErrorCreatingToken: 'An internal server error occurred while creating the token.',
      invalidAdminManagementResponse: 'Invalid response from the admin management service.',
      invalidDealName: 'Invalid deal name.',
      invalidInputs: 'One or more inputs are invalid.',
      invalidIntsProvided: 'Please enter valid numbers.',
      invalidLevelProvided: 'Invalid level provided.',
      invalidNotificationsResponse: 'Invalid response from the notifications service.',
      invalidOrgOrDeal: 'Invalid request: missing organization details or deal ID.',
      invalidRequest: 'Invalid request.',
      invalidRequestParameters: 'Invalid request parameters.',
      invalidSchoolDealNames:
        'School name, deal name, and school manager names must not contain numbers, and first/last names must not exceed 40 characters.',
      invitationLinkNotFound: 'Invitation link not found.',
      languagePreferencesNotFound: 'Language preferences not found for this school.',
      levelSummariesNotFound: 'Level summaries not found.',
      noDataFound: 'No data found.',
      noDataFoundForIds: 'No data found for the provided IDs.',
      noRegionsFound: 'No regions found.',
      notificationsServiceNotConfigured: 'The notifications service is not configured.',
      operationNotFound: 'Operation not found.',
      organizationDoesNotExist:
        'The organization does not exist. No new users can be registered at this time.',
      ownDevicesOnly: 'You can only register devices for your own account.',
      reportRequestTimedOut:
        'The request timed out while generating the report. Please, try again later.',
      requestBodyRequired: 'Request body is required.',
      requestCanceled: 'The request was cancelled. Please, try again later.',
      requestCanceledRetry: 'The request was cancelled. Please, try again later.',
      requestCannotBeNull: 'The request cannot be empty.',
      requestNotProcessed: 'The request did not process successfully. Please, try again later.',
      schoolAndTeacherIdRequired: 'School ID and Teacher ID are required.',
      schoolIdRequired: 'School ID is required.',
      schoolNotFound: 'School not found.',
      searchQueryRequired: 'Search query is required.',
      studentCreationTimedOut:
        'The request timed out while creating students. The operation may still be processing — please wait a moment and refresh to verify.',
      studentDataNotFoundOrDenied: 'Student data not found or access is denied.',
      studentProgressNotFound: 'Student progress data not found.',
      studentReportNotFound: 'Student report not found.',
      studentRequestRequired: 'The student request cannot be empty.',
      studentsNotFound: 'Students not found.',
      studentsReportNotFound: 'Students report not found.',
      studentsReportTimedOut:
        'The request timed out while retrieving the students report. Please, try again later.',
      teacherDetailsNotFound: 'Teacher details not found.',
      teacherIdRequired: 'Teacher ID is required.',
      teacherNotFound: 'Teacher not found.',
      teachersNotFound: 'Teachers not found.',
      teachersReportNotFound: 'Teachers report not found.',
      teachersReportTimedOut:
        'The request timed out while retrieving the teachers report. Please, try again later.',
      tokenCreationFailed: 'Token creation failed. Please, try again later.',
      unableToParseServerResponse:
        "Unable to parse the server's response. Students may have been created — please refresh and verify.",
      unableToProcessRequest: 'Unable to process your request. Please, try again later.',
      unableToRetrieveGroupsReport:
        'Unable to retrieve the groups report. Please check your request and try again.',
      unableToRetrieveStudentsReport:
        'Unable to retrieve the students report. Please check your request and try again.',
      unableToRetrieveTeachersReport:
        'Unable to retrieve the teachers report. Please check your request and try again.',
      unauthorized: 'Action unauthorized.',
      unexpectedDealServiceResponse: 'Unexpected response from the deal service.',
      unexpectedWithRef:
        'An unexpected error occurred. Please try again or contact support. (Ref: {{ref}})',
      unregisterOwnDevicesOnly: 'You can only unregister your own devices.',
      updateRequestBodyRequired: 'The update request body is required.',
      updatesRequired: 'Updates are required.',
      userAuthContextRequired: 'User authentication context is required.',
      userDoesNotExist: 'The requested user does not exist.',
      userIdentityRequired: 'User identity is required.',
      userNotFound: 'User not found.',
      userOrgDetailsNotFound: 'User organization details not found.',
      userPartiallyDeleted:
        'User deleted only from some systems, but not from all. Please try again or contact support.',
      validTeacherOrgIdRequired: 'A valid Teacher ID and Organization ID are required.',
      verificationCodeInvalid: 'The verification code is invalid.',
    },
    somethingWentWrong: 'Algo deu errado. Tente novamente mais tarde',
    wafBlocked: {
      description:
        'This action has been temporarily blocked for security reasons. Please try again in a few minutes.',
      eyebrow: 'Access Blocked',
      title: 'Oops...',
    },
    weHadAProblem: 'Ops! Ocorreu um problema.',
  },
  exampleEmail: 'exemplo@gmail.com',
  exampleSentences: 'Exemplos de frases',
  examples: 'exemplos',
  exit: 'Sair',
  exploreEngaging:
    'Explore atividades envolventes e divertidas que tornarão a aprendizagem de inglês agradável e eficaz.',
  extra: 'Extra',
  extraCoins: 'Moedas extras',
  failed_quiz_message_first:
    'Você não foi aprovado nessa atividade, portanto não receberá estrelas.',
  failed_quiz_message_passed:
    'Você não foi aprovado. Não se preocupe, sua pontuação anterior foi salva.',
  failureRate: 'Índice de reprovação',
  fewMoreSeconds: 'Mais alguns segundos',
  fieldIsMandatory: 'Este campo é obrigatório',
  filter: 'Filtrar',
  finalAssessment: 'Avaliação final',
  finalEnglishLevelTest: 'Teste final de nível de inglês',
  finishActivity: 'Concluir atividade',
  finishGameText:
    'Você concluiu seu curso no Hello Britannica. <br/>Todas as suas atividades permanecerão desbloqueadas para que você possa voltar e praticar',
  finishToLevelUp: 'Termine para subir de nível!',
  finishUnitSuccessText:
    'Você completou a unidade {{completedUnitName}}. Você está pronto para começar {{nextUnitName}}. Lembre-se: você sempre pode retornar a essa unidade para rever seu conteúdo.',
  firstLogin: 'Primeiro login',
  firstname: 'Nome',
  focus: 'Foco!',
  for: 'para',
  forgotPassword: 'Esqueci a senha',
  fridayShort: 'Sex',
  from: 'De',
  fullVersionAvilableOnlyOnDesktop: 'Versão completa disponível apenas no desktop',
  generateClassReport: 'Gerar relatório de turma',
  generateReport: 'Gerar relatório',
  genericTable: {
    bimloaFilter: {
      all: 'Todos',
      close: 'Fechar',
      from: 'De:',
      reset: 'Redefinir',
      resetAll: 'Redefinir tudo',
    },
    dropDown: {
      placeholder: 'Selecionar',
    },
    noResultsForSearch: 'Nenhum resultado encontrado para sua pesquisa ou filtro.',
  },
  getApp: 'Baixar o aplicativo',
  getFullExperience: 'Obtenha a experiência completa com o aplicativo Hello Britannica',
  getStarted: 'Iniciar',
  giveFeedback: 'Fale conosco',
  goAheadAndShareThisLinkWithYourStudentsNow: 'Compartilhe este link com seus alunos agora.',
  goBack: 'Voltar',
  goForward: 'Avançar',
  goToLevelTest: 'Ir para o teste de nivelamento',
  go_back_btn: 'Botão Voltar',
  goodAfternoon: 'Boa tarde',
  goodEvening: 'Boa noite',
  goodJob: 'Bom trabalho!',
  goodLuck: 'Boa sorte!',
  goodMorning: 'Bom dia',
  goodNight: 'Boa noite',
  googleDataAdded: 'As turmas selecionadas foram adicionadas com sucesso!',
  googleDataAddedDescription:
    'Depois que os alunos fizerem login na plataforma, eles precisarão fazer um teste de nivelamento. Com base nos resultados, eles serão designados para o nível apropriado e iniciarão sua jornada de aprendizagem.',
  googleDataSynced: 'Seus dados foram sincronizados!',
  googleDataSyncedDescription:
    'Todos os dados do Google Sala de Aula e do Hello agora estão sincronizados.',
  googleStudentIsInactive:
    'Esse aluno está inativo. Ele foi convidado para a turma, mas ainda não iniciou o teste de nivelamento inicial.',
  googleStudentsAlreadyInOtherGroups:
    'Os alunos a seguir não foram adicionados à turma pois pertencem à turma de outro professor:',
  grade: 'Ano/série',
  grade_1: '1º ano (EFAI)',
  grade_10: '1ª série (EM)',
  grade_11: '2ª série (EM)',
  grade_12: '3ª série (EM)',
  grade_13: 'Ensino Superior',
  grade_14: 'Nenhum',
  grade_2: '2º ano (EFAI)',
  grade_3: '3º ano (EFAI)',
  grade_4: '4º ano (EFAI)',
  grade_5: '5º ano (EFAI)',
  grade_6: '6º ano (EFAF)',
  grade_7: '7º ano (EFAF)',
  grade_8: '8º ano (EFAF)',
  grade_9: '9º ano (EFAF)',
  grade_none: 'Nenhum',
  grade_university: 'Ensino Superior',
  grammar_tip: 'Dica de gramática',
  great: 'Ótimo!',
  greatJob: 'Ótimo trabalho!',
  guides: 'Guias',
  hello: 'Olá',
  helloBritannica: 'Hello Britannica',
  helloLoader: 'Olá',
  helloTeacher: 'Olá 👋🏻',
  help: 'Ajuda',
  hi: 'Oi',
  hints: 'Dicas',
  hints_options: {
    add_more_time: 'Adicionar tempo no relógio',
    hear_the_english_word: 'Ouça a palavra em inglês',
    remove_a_letter: 'Remover uma letra',
    remove_one_answer: 'Remover uma resposta',
    reveal_a_pair: 'Revelar um par',
    see_the_translation: 'Ver tradução',
    see_the_word: 'Ver palavra',
    show_a_letter: 'Mostrar uma letra',
  },
  homepage: 'Página inicial',
  howDidYouDo: 'Como você se saiu?',
  howsYourEnglish: 'Como está seu inglês?',
  iAgree: 'Concordo',
  iAgreeTo: 'Eu concordo com',
  iAmReady: 'Estou pronto!',
  iDidntUnderstand: 'Não entendi. Tente novamente.',
  iDoNotAgree: 'Não concordo',
  id: 'Identificação',
  illDoItLater: 'Farei mais tarde',
  importClasses: 'Importar turma',
  importYourFirstClass: 'Importe sua primeira turma do Google Sala de Aula!',
  importYourFirstClassDescription:
    'Importe sua turma do Google Sala de Aula para o Hello e, em seguida, seus alunos poderão participar',
  improveYourLastActivities: 'Aprimore suas atividades mais recentes',
  in_order_to_start: 'Para iniciar sua jornada de aprendizagem, precisamos',
  inactive: 'Inativo',
  incorrect: 'Incorreto!',
  incorrect_answer: 'incorreto.',
  initialLevelTest: 'Teste inicial de nivelamento',
  interfaceLanguage: 'Idioma da interface',
  interface_language: 'Idioma da interface',
  invalidCode: 'Código inválido',
  invalidEmail: 'E-mail inválido',
  invalidEmailOrUsername: 'E-mail ou nome de usuário inválidos',
  invalidField: 'Campo inválido',
  invalidFirstname: 'Nome inválido',
  invalidLastname: 'Sobrenome inválido',
  invalidOrganizationName: 'School name contains invalid characters.',
  invalidPassword: 'Senha inválida',
  invalidUsername:
    'O nome de usuário deve conter somente letras, números e os seguintes símbolos: _ . - Não são permitidos espaços. Máximo de 20 caracteres.',
  invalidUsernameOrPassword: 'Nome de usuário ou senha inválidos',
  invalidUsernameinForgotPassword:
    'Algo deu errado com o nome de usuário "{{username}}”. Entre em contato com o seu professor para obter ajuda.',
  invitationLink: 'Link de convite',
  invitationLinkWontChange: 'Não se preocupe, o link de convite não será alterado',
  inviteYourStudents: 'Convide seus alunos',
  inviteYourTeachers: 'Convide seus professores para participar',
  invitedToJoin: 'convidado a participar do Hello Britannica.',
  invitedToJoinMorfix: 'convidado a se juntar ao Morfixschool 2.0.',
  isNotEnglish: 'Você deve responder esta atividade em inglês. Tente novamente.',
  itLooksLikeYourLevel:
    'Parece que o nível {{level}} é o mais apropriado. Continue praticando e você continuará melhorando!',
  itLooksLikeYourLevelMax:
    'Bom trabalho! O nível {{level}} é o mais adequado para você. Vamos começar.',
  itsTime: 'É hora de escolher se você está pronto para o jogo ou não,',
  joinNow: 'Cadastre-se agora',
  keepGoing: 'Continuar',
  keepPlaying: 'Continue jogando',
  keepPracticing: 'Continue praticando',
  know: 'conheço',
  know_your_level: 'saiba seu nível de inglês.',
  language: 'Idioma',
  language_of_study: 'Idioma de estudo',
  languages: {
    ar: 'Árabe',
    en: 'Inglês',
    es: 'Espanhol',
    he: 'Hebraico',
    pt: 'Português',
  },
  lastLogin: 'Último login',
  lastUncorrectPronounce: 'Pula para a próxima pergunta.',
  lastUnitCongratulation:
    'Você completou o nível <strong> {{currentLevel.name}} </strong> <br/> e está a caminho do nível <strong> {{nextLevel.name}}</strong>.',
  lastname: 'Sobrenome',
  learn: '{{lessons}} aulas disponíveis',
  leave_level_test_and_sign_out: 'Sair do teste de nivelamento?',
  letsAssess:
    'Vamos verificar seu nível atual de inglês com um breve quiz para que possamos oferecer a melhor experiência de aprendizagem. Pode levar de 5 a 15 minutos com base no seu desempenho. Preparado?',
  letsBegin: 'Vamos começar',
  letsFinish: 'Vamos encerrar',
  letsGo: 'Vamos lá',
  letsKeepLearning: 'Vamos continuar aprendendo!',
  letsSee: 'Vamos ver o quanto você conhece seu vocabulário.',
  level: 'Nível',
  levelChanged: 'Seu nível mudou.',
  levelChangedDescription:
    'Observação: Seu progresso e atividade anteriores foram reiniciados para refletir sua nova trilha de aprendizagem.',
  levelChangedDown: 'Seu professor ajustou seu nível de aprendizagem.',
  levelChangedDownDescription:
    'Essa alteração tem como objetivo ajudá-lo a fortalecer as principais habilidades antes de seguir em frente — você consegue.',
  levelChangedUp: 'Seu professor transferiu você para um nível mais alto.',
  levelChangedUpDescription: 'Bom trabalho! Continue a se desafiar!',
  levelName_1: 'Starter (Pre-A1)',
  levelName_2: 'Beginner (A1)',
  levelName_3: 'Pre-Intermediate (A2)',
  levelName_4: 'Intermediate (B1)',
  levelName_5: 'Upper Intermediate (B2)',
  levelName_6: 'Advanced (C1)',
  levelTest: 'Teste de nivelamento',
  levelTestIncomplete: 'Teste de nivelamento incompleto',
  levelTestPausedDescription:
    'As últimas {{count}} perguntas não serão salvas e você terá de respondê-las novamente.',
  level_test: 'Teste de nivelamento',
  linkCopied: 'Link copiado!',
  listen_tip: 'Ouvir dica',
  listeningTapToFinish: 'Ouvindo',
  loginFromDifferent: 'Faça login com uma conta diferente',
  logout: 'Sair',
  longClassName: 'O nome da turma pode ter até 40 caracteres.',
  melingoCalculateYourLevel: 'Estamos calculando seu nível...',
  memoryGameTitle: 'Vire as cartas para encontrar seis correspondências entre textos e imagens.',
  menu_button: 'Botão Menu',
  message: 'Mensagem',
  mgWebsite: {
    loginFormButton: 'Continuar com Google',
    loginFormSubTitle:
      ' <div>Clique abaixo para fazer login com sua </div> <div> conta do Google — é rápido, simples e seguro! </div> ',
    loginFormTitle: 'Olá! Que bom ver você!',
  },
  microphoneRestricted: 'O acesso ao microfone é restrito em seu computador',
  missingGooglePermissionsPopup: {
    button: 'Atualizar permissões',
    description: 'Após conceder permissão, você poderá iniciar sua jornada com o Hello!',
    title: 'Conceda acesso ao "Hello"',
  },
  mondayShort: 'Seg',
  months: {
    apr: 'Abr',
    aug: 'Ago',
    dec: 'Dez',
    feb: 'Fev',
    jan: 'Jan',
    jul: 'Jul',
    jun: 'Jun',
    mar: 'Mar',
    may: 'Mai',
    nov: 'Nov',
    oct: 'Out',
    sep: 'Set',
  },
  multiSelectDropDown: {
    loadMore: 'Carregar mais',
    loading: 'Carregando...',
    noResults: 'Nenhum resultado encontrado',
    removeAll: 'Remover tudo',
    selected: 'selecionado',
    typeText: 'Digite para pesquisar',
  },
  myPrivateTutor: 'Meu tutor particular',
  myProfile: 'Meu perfil',
  myProgress: 'Progresso do aluno',
  myProgressCompletedNotice:
    'Congratulations! Your assigned level is complete. Revisit these activities anytime for more practice.',
  my_tutor_page: {
    avatarLabel: 'AI-generated',
    commonMistakeDescription:
      'Você pode praticar o que aprimorou ou visualizar a conversa relevante',
    commonMistakes: 'Dicas',
    completedActivities: '{{numberOfCompletedActivities}}concluídas! Muito bem! 🏆',
    filterOptions: {
      enhancementArea: 'Tipo de erro',
      enhancementAreaSearchPlaceholder: 'Pesquisar tipo de erro',
      score: 'Pontuação',
      status: 'Tipo de atividade',
      statusSearchPlaceholder: 'Pesquisar tipo de atividade',
    },
    group: {
      filters: {
        all: 'Todos',
        currentDate: 'Especifique a data',
        date: 'Datas das conversações',
        last7days: 'Últimos 7 dias',
        level: 'Nível atual',
        rangeDate: 'Período',
        topic: 'Tópicos',
      },
      table: {
        avgConversationTime: 'Tempo médio de conversação',
        conversation: 'Conversações',
        lastConversation: 'Última conversação',
        lastTopic: 'Último tópico',
        level: 'Nível atual',
        name: 'Nome do aluno',
        noResultsMessage: 'Nenhum resultado encontrado para sua pesquisa ou filtro.',
        title: 'Alunos',
        topics: 'Tópicos',
      },
    },
    jumpBackInSubtitle: 'You did great — now you can try again and get even better!',
    learn1: 'Faltam {{totalLessonsCount}} quizzes ',
    learnN: 'Faltam {{totalLessonsCount}} quizzes',
    letsPractice: 'Vamos praticar!',
    myDashboard: 'Meu painel',
    noActivities:
      '"Let’s talk so I will be able to know your needs and suggest practice accordingly! 😊',
    practiceBtn: 'Praticar',
    practiceCount: 'You have {{count}} practice suggestion',
    practiceCountPlural: 'You have {{count}} practice suggestions',
    quizStatus: {
      COMPLETED: 'Concluído',
      IMPROVEMENT: 'Aprimoramento',
      PRACTICE: 'Praticar',
    },
    repeatTopic: 'Repeat Topic',
    report: {
      avgConversationDuration: 'Duração média',
      avgMistakes: 'Média de correções',
      cefr: 'Quadro Comum Europeu de Referência para Línguas (CEFR)',
      conversation1: '{{numberOfConversations}} conversas',
      conversationLevel: 'Nível',
      conversationSummary: 'Resumo da conversa',
      conversationsN: '{{numberOfConversations}} conversas',
      description: 'Descrição',
      duration: 'Duração',
      errorsFound: 'Observado {{errors}} vezes',
      evaluationSummary: 'Conversation Evaluation',
      topicOfConversation: 'Tópico da conversa',
      totalConversations: 'Total de conversas',
      watchHistory: 'Revise a conversa',
    },
    score: 'Pontuação',
    seeMyChatsBtn: 'Ver todos >',
    showMoreHistory: '+ Mostrar mais',
    sortOptions: {
      createdDateAscending: 'Data, mais antiga até mais recente',
      createdDateDescending: 'Data, da mais recente para mais antiga',
      rankAscending: 'Classificação, baixa para alta',
      rankDescending: 'Classificação, alta para baixa',
      scoreAscending: 'Pontuação, da menor para maior',
      scoreDescending: 'Pontuação, da maior para menor',
      statusAscending: 'Status, das praticadas às concluídas',
      statusDescending: 'Status, das concluídas às praticadas',
      topicAscending: 'Tópico (A-Z)',
      topicDescending: 'Tópico (Z-A)',
    },
    statistics: {
      averageConversationTime: '⏱️ Tempo médio de conversação',
      filter: {
        month: 'Últimos 30 dias',
        rangeDate: 'Seletor de data personalizado',
        staticTitle: 'Exibir dados de:',
        week: 'Esta semana',
      },
      studentsUsingTutor: '💬 Alunos usando tutor',
      totalStudents: '👤 Total de alunos',
    },
    youCanDoIt: '🚀 Você conseguiu!',
    youHas1Chat: 'Você possui 1 chat',
    youHasNChat: 'Você possui {{numberOfConversations}} chats',
    yourChats: 'Your Chats',
  },
  nameAndStatus: 'Nome e status',
  needHelp: 'Precisa de ajuda?',
  new_password: 'Nova senha',
  new_password_verification: 'Digite novamente a nova senha',
  next: 'Avançar',
  nextPage: 'Próxima página',
  nextQuestion: 'Próxima pergunta',
  nextQuiz: 'Próxima atividade',
  nextWord: 'Próxima palavra',
  niceEffort: 'Bom trabalho,',
  noClassToImport: 'Não há turmas para importar',
  noClassToImportDescription:
    'Primeiro, você precisa criar suas turmas em sua página do Google Sala de Aula https://classroom.google.com/ e, então, poderá importar seus alunos para cá',
  noExtraCoins: 'Sem moedas extras',
  noLevelAssignedMessage: 'Please ask your teacher to set your level so you can start.',
  noLevelAssignedTitle: "You don't have a level assigned yet.",
  noLongerAvailable: 'Não está mais disponível — excluído no Google Sala de Aula',
  noStudentMistake: 'Caso você tenha alunos nesta turma, entre em contato com o gestor escolar. ',
  noStudents: 'Não há alunos nesta turma',
  noTrailingSpaces: 'O nome não pode ter espaços no final',
  none: 'Nenhum',
  notAvailable: 'N/D',
  notFoundError: 'Erro 404',
  notMadeIt: 'Parece que você não conseguiu dessa vez. Você pode',
  notifications: {
    event: {
      accountDeleted: {
        body: 'Sua conta Hello foi excluída.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity your Hello account has been deleted.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity your Hello account has been deleted.',
        title: 'Sua conta foi excluída.',
      },
      adminDealExpired: {
        body: 'Your school’s Hello Britannica subscription has expired. Access through the website and our apps has been disabled for all users in your school. To renew your subscription and reinstate access, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
        title: 'Your school’s Hello Britannica subscription has expired',
      },
      assignedToNewClass: {
        actionText:
          'Please invite students to join your class or add them yourself through the Hello platform.',
        body: 'Você foi designado para {{className}}.',
        title: "You've been assigned to a class",
      },
      classDeleted: {
        body: '{{className}} foi excluída.',
        title: 'Your class has been deleted',
      },
      classGradeEdited: {
        body: 'O ano/série de {{className}} foi alterado de {{oldGradeStr}} para {{newGradeStr}}.',
        title: 'Your class grade has been updated',
      },
      classNameEdited: {
        body: '{{oldClassName}} foi renomeada como {{newClassName}}.',
        title: 'Your class has been renamed',
      },
      classesDeleted: {
        body: '{{numberOfClasses}} turmas foram excluídas.',
        body_one: '1 turma foi excluída.',
        title: 'Your classes have been deleted',
      },
      coTeacherAdded: {
        body: '{{teacherFullName}} was assigned to your class {{className}}.',
        title: 'Co-Teacher was added to your class',
      },
      coTeacherAssignedToNewClass: {
        actionText:
          'Please invite students to join your class or add them yourself through the Hello platform.',
        body: 'You have been assigned to {{className}}.',
        title: "You've been assigned to a class",
      },
      coTeacherRemoved: {
        body: '{{teacherFullName}} was removed from your class {{className}}.',
        title: 'Co-Teacher was removed from your class',
      },
      dealDateExpirationUpdated: {
        body: 'Your school’s Hello Britannica subscription expiration date has been updated to {{dateStr}}.',
        title: 'Expiration date changed for your school’s Hello Britannica subscription',
      },
      interfaceLanguageChanged: {
        body: 'O idioma da interface foi alterado para {{newLanguageStr}}.',
        title: 'Your interface language has been updated',
      },
      levelChanged: {
        body: 'Seu nível de inglês foi alterado de {{oldLevel}} para {{newLevel}}.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity your level has been changed from {{oldLevel}} to {{newLevel}}.<br/>You will now be redirected to the next level.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity your level has been changed from {{oldLevel}} to {{newLevel}}.<br/>You will now be redirected to the next level.',
        title: 'Seu nível foi atualizado.',
      },
      levelTestNotFinished: {
        body: 'Come back and finish a few more questions to begin practicing with Hello Britannica.',
        title: 'Say "Hello" to learning English',
      },
      levelTestNotTaken: {
        body: 'Check your English with a short quiz to unlock activities.',
        title: 'Get started with Hello Britannica',
      },
      licenseLimitReached: {
        actionText:
          'To extend your subscription with additional licenses, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
        body: 'Sua escola atingiu o limite de licenças. Não é possível matricular mais alunos. Entre em contato com o Hello Britannica para solicitar mais licenças.',
        title: 'License limit reached',
      },
      movedToDifferentClass: {
        body: 'Você foi transferido de {{oldClassName}} para {{newClassName}}.',
        title: "You've been moved to a new class",
      },
      movedToDifferentClassWithLevelSet: {
        body: 'Your level was set to {{newLevel}}. Please log in again to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity you were assigned to a new class. Your level was set to {{newLevel}}. Please log in again to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity you were assigned to a new class. Your level was set to {{newLevel}}. Please log in again to get started.',
        title: 'You were assigned to a new class',
      },
      movedToDifferentClassWithPlacementTestRequired: {
        body: 'You are now required to take the level test. Please log in again and complete it to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity you were assigned to a new class. You are now required to take the level test. Please log in again and complete it to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity you were assigned to a new class. You are now required to take the level test. Please log in again and complete it to get started.',
        title: 'You were assigned to a new class',
      },
      nameChanged: {
        body: 'Seu nome foi atualizado para {{newFullName}}.',
        title: 'Your name has been updated',
      },
      removedFromClass: {
        body: 'Você foi removido de {{className}}.',
        title: "You've been removed from a class",
      },
      studentAdvancedToNewLevel: {
        body: '{{studentFullName}} de {{className}} avançou de {{oldLevel}} para {{newLevel}}.',
        title: 'A student reached a new level',
      },
      studentDealExpired: {
        body: 'Access to Hello Britannica has ended for your school. Please contact your teacher or school administrator for more information.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        title: 'Platform access has ended',
      },
      studentDeleted: {
        body: '{{studentFullName}} foi excluído de {{className}}.',
        title: 'A student has been deleted from your class',
      },
      studentGroupAllowIndividualAdvancement: {
        body: 'You will now advance to the next level.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. You will now advance to the next level.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. You will now advance to the next level.',
        title: 'A setting for your class has been changed.',
      },
      studentGroupLevelSet: {
        body: 'Your level was set to {{newLevel}}. Please log in again to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. Your level was set to {{newLevel}}. Please log in again to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. Your level was set to {{newLevel}}. Please log in again to get started.',
        title: 'A setting for your class has been changed.',
      },
      studentGroupPlacementTestRequired: {
        body: 'You are now required to take the level test. Please log in again and complete it to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. You are now required to take the level test. Please log in again and complete it to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. You are now required to take the level test. Please log in again and complete it to get started.',
        title: 'A setting for your class has been changed.',
      },
      studentInactivityDigest1m: {
        body: '{{numberOfStudents}} students have not engaged in Hello Britannica in the past month.',
        body_one: '1 student has not engaged in Hello Britannica in the past month.',
        title: 'Assign your students activities to complete in Hello Britannica',
      },
      studentInactivityDigest2w: {
        body: '{{numberOfStudents}} students have not engaged in Hello Britannica in the past two weeks.',
        body_one: '1 student has not engaged in Hello Britannica in the past two weeks.',
        title: 'Encourage your students to practice English with Hello Britannica',
      },
      studentWeeklyInactivity: {
        body: 'You scored {{lastCompletedActivityScore}} on your last Hello Britannica activity. Can you beat it?',
        body_noScore:
          "You haven't completed any Hello Britannica activity yet. Why won't you try it?",
        title: 'Don’t forget to practice your English today!',
      },
      studentsAssignedToClassByAdmin: {
        actionText:
          'Please ensure the new students complete the level test so they can start playing.',
        body: '{{numberOfStudents}} alunos foram adicionados em {{className}}.',
        body_one: '1 aluno foi adicionado em {{className}}.',
        title: 'Students have been added to your class',
      },
      studentsDeleted: {
        body: '{{numberOfStudents}} alunos foram excluídos de {{className}}.',
        body_one: '1 aluno foi excluído de {{className}}.',
        title: 'Students have been deleted from your class',
      },
      studentsJoinedSinceLastLoginWithOutStudents: {
        body: 'No students have joined your school since your last login.',
        title: 'New students since your last login',
      },
      studentsJoinedSinceLastLoginWithStudents: {
        body: '{{numberOfStudents}} students have joined your school since your last login.',
        body_one: '1 student has joined your school since your last login.',
        title: 'New students since your last login',
      },
      studentsJoinedViaTeacherInvitation: {
        actionText:
          'Please ensure the new students complete the level test so they can start playing.',
        body: '{{numberOfStudents}} alunos entraram em {{className}}.',
        body_one: '1 aluno entrou em {{className}}.',
        title: 'A student has joined your class',
      },
      studentsLevelChangedByOperator: {
        body: '{{studentFullName}}’s English level has been changed from {{oldLevel}} to {{newLevel}}.',
        title: 'Your student’s level has been changed',
      },
      studentsMovedOutOfTheClass: {
        body: '{{numberOfStudents}} alunos foram transferidos de {{oldClassName}} para {{newClassName}}.',
        body_one: '1 aluno foi transferido de {{oldClassName}} para {{newClassName}}.',
        title: 'Students moved out of the class',
      },
      teacherCreatedNewClass: {
        body: '{{className}} foi criada.',
        title: 'A new class has been created',
      },
      teacherDealExpired: {
        body: 'Access to Hello Britannica has ended for you and your students. Please contact your school administrator for more information.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        title: 'Hello Britannica access has ended',
      },
      teacherDeletedClassWithOutStudents: {
        body: '{{className}} foi excluída.',
        title: 'A class has been deleted',
      },
      teacherDeletedClassWithStudents: {
        body: '{{className}} foi excluída. {{numberOfStudents}} alunos também foram excluídos.',
        body_one: '{{className}} foi excluída. 1 aluno também foi excluído.',
        title: 'A class has been deleted',
      },
      topicCompletedLowScore: {
        body: '{{studentFullName}} completed a topic with scores lower than 70 in skills: {{skillsListStr}}.',
        body_one:
          '{{studentFullName}} completed a topic with a score lower than 70 in {{skillsListStr}}.',
        title: 'Your student may need extra help',
      },
      weeklyClassSummaryWithActivity: {
        body: 'Here is your weekly summary of activity in Hello Britannica for {{className}} (week of {{dateStr}}): {{numberOfStudentsAdvancedToNewLevel}} students advanced to a new level / {{numberOfStudentsCompletedUnit}} students completed a unit / {{numberOfStudentsWereAdded}} students were added / {{numberOfStudentsWereDeleted}} students were deleted.',
        title: 'Weekly Report - Hello Britannica activity summary for {{className}}',
      },
      weeklyClassSummaryWithOutActivity: {
        body: "Here is your weekly summary of activity in Hello Britannica for {{className}} (week of {{dateStr}}): nothing has changed this week. Encourage your students to practice their English with Hello Britannica regularly and you'll see them completing units in no time!",
        title: 'Weekly Report - Hello Britannica activity summary for {{className}}',
      },
      weeklySchoolSummaryWithActivity: {
        body: 'Here is your weekly summary for {{schoolName}} (week of {{dateStr}}): {{numberOfStudentsWereAdded}} students were added / {{numberOfStudentsWereDeleted}} students were deleted / {{numberOfTeachersHaveJoined}} teachers have joined / {{numberOfClassesWereCreated}} classes were created / {{numberOfStudentsAdvancedToNewLevel}} students advanced to a new level.',
        title: 'Weekly Report - Hello Britannica activity summary for {{schoolName}}',
      },
      weeklySchoolSummaryWithOutActivity: {
        body: 'Here is your weekly summary for {{schoolName}} (week of {{dateStr}}): nothing has changed this week. To get the most out of Hello Britannica, remind teachers to encourage their students to practice their English language skills regularly.',
        title: 'Weekly Report - Hello Britannica activity summary for {{schoolName}}',
      },
    },
    list: {
      allNotificationsMessage: 'Sem notificações nos últimos 30 dias.',
      markAllAsReadButton: 'Marcar todas como lidas',
      noNotificationsMessage: 'Sem notificações novas.',
      sendDataWithOperator: '{{createdAtStr}} | por {{operatorFirstName}} {{operatorLastName}}',
      sendDataWithoutOperator: '{{createdAtStr}}',
      title: 'Notificações',
    },
    popup: {
      okButton: 'OK',
    },
  },
  ofThisSite: 'deste site.',
  offlineNotification: {
    button: 'OK',
    description: 'When you will be online again, you will be able to continue using the platform.',
    title: 'You are currently offline.',
  },
  ok: 'Ok',
  okLetsGo: 'Ok, vamos lá!',
  oneMoreMistake: 'Um erro a mais encerrará o jogo,',
  onlyNumbersAllowed: 'Somente números são permitidos',
  oops: 'Opa!',
  oopsDots: 'Ops...',
  orClickHereToSendAgain: 'Ou <0> clique aqui </0> para reenviar o código.',
  orLoginWithGoogle: 'Ou continue com o Google Sala de Aula',
  organizationNameTooLong: 'School name can be up to 70 characters.',
  outOf: 'de',
  overallProgress: 'Progresso geral',
  pageNotFound: 'Página não encontrada',
  partialImportError:
    'Algumas turmas não puderam ser importadas porque já foram importadas por outro professor. As turmas restantes foram importadas com sucesso.',
  passRate: 'Índice individual de aprovação',
  password: 'Senha',
  passwordMinimumLength: 'Tamanho mínimo de 8 caracteres',
  password_changed_successfully: 'Senha alterada com sucesso',
  passwordsDontMatch: 'As senhas não coincidem',
  pause_game: 'Pausar jogo',
  paussed: 'Pausado',
  phone: 'Telefone',
  pictureOfTheDay: 'Imagem do dia',
  play_sound: 'Reproduzir som',
  pleaseChooseYourOwnPassword: 'Escolha sua própria senha',
  pleaseEnterTheFollowing: 'Insira as seguintes informações para dar início à sua',
  pleaseEnterYourDetails: 'Insira seus dados',
  pleaseSelectYourAccount: 'Selecione sua conta ou faça login em outra conta',
  pleaseTakeAMoment: 'Reserve um momento para registrar sua escola.',
  pleaseTryAgain: 'Tente novamente.',
  practice: 'Praticar',
  practiceAgain: 'Praticar novamente',
  practiceProperPronunciation:
    'Pratique a pronúncia de palavras ou frases novas. Clique no microfone azul e pronuncie-as. Em seguida, clique no microfone azul novamente quando terminar. Fale devagar.',
  practiceYourVocabulary: 'Pratique seu vocabulário',
  preferences: 'Preferências',
  premiumSection: {
    description:
      'Aqui você pode ver informações importantes ou recursos do administrador da escola ou da Britannica.',
    title: 'Uma mensagem para os professores',
    unlock: 'Desbloqueie Premium',
  },
  preparationAudioToImage:
    'Esta é uma atividade de compreensão auditiva divertida. Clique no botão e ouça o áudio. Em seguida, combine-o com a imagem correta.',
  preparationAudioToImageMobile:
    'Esta é uma atividade de compreensão auditiva divertida. Clique no botão e ouça o áudio. Em seguida, combine-o com a imagem correta.',
  preparationClosedSpelling:
    'Esta é uma maneira divertida de praticar ortografia. Observe a imagem. Use as letras para soletrar as palavras. ',
  preparationClosedSpellingMobile:
    'Essa é uma maneira divertida de praticar ortografia. Observe a imagem. Use as letras para soletrar as palavras. ',
  preparationDescriptionFirstPart:
    'Esta é uma atividade de compreensão auditiva divertida. Clique no botão e ouça o áudio. Em seguida, combine-o com a imagem correta.',
  preparationDescriptionFirstPartMobile:
    'Esta é uma atividade de compreensão auditiva divertida. Clique no botão e ouça o áudio. Em seguida, combine-o com a imagem correta.',
  preparationDescriptionSecondtPart: 'É como um quebra-cabeça que ajuda você a aprender inglês!',
  preparationGrammar:
    'Leia as perguntas e selecione a opção correta. Consulte a dica de gramática! Preparado? Vamos praticar gramática!',
  preparationGrammarMobile:
    'Leia as perguntas e selecione a opção correta. Consulte a dica de gramática! Preparado? Vamos praticar gramática!',
  preparationImageToText:
    'Aprenda inglês e divirta-se! Observe a imagem e combine-a com a opção correta.',
  preparationImageToTextMobile:
    'Aprenda inglês e divirta-se! Observe a imagem e combine-a com a opção correta.',
  preparationListen:
    'Divirta-se praticando sua compreensão auditiva! Clique no botão e ouça. Em seguida, selecione a resposta correta.',
  preparationListenMobile:
    'Divirta-se praticando sua compreensão auditiva! Clique no botão e ouça. Em seguida, selecione a resposta correta.',
  preparationMemory:
    'Divirta-se e pratique inglês! Faça correspondências entre as palavras as imagens. ',
  preparationMemoryMobile:
    'Divirta-se e pratique inglês! Faça correspondências entre as palavras as imagens. ',
  preparationNaturalConversation:
    'Pratique a pronúncia do inglês! Clique no botão e ouça. Selecione a resposta correta. Em seguida, clique no microfone azul e pronuncie-a em voz alta. Clique no microfone azul novamente quando terminar. ',
  preparationNaturalConversationMobile:
    'Pratique a pronúncia do inglês! Clique no botão e ouça. Selecione a resposta correta. Em seguida, clique no microfone azul e pronuncie-a em voz alta. Clique no microfone azul novamente quando terminar. ',
  preparationOpenWriting:
    'Pratique sua escrita de uma maneira divertida! Leia a pergunta e observe a imagem. Em seguida, escreva a resposta. ',
  preparationOpenWritingMobile:
    'Pratique sua escrita de uma maneira divertida! Leia a pergunta e observe a imagem. Em seguida, escreva a resposta. ',
  preparationRead: 'Leia e responda às perguntas. Vamos lá!',
  preparationReadMobile: 'Leia e responda às perguntas. Vamos lá!',
  preparationSecondtPartGrammar:
    'Não se preocupe, você receberá dicas ao longo do caminho para ajudar.',
  preparationSecondtPartImageToText: 'Boa sorte!',
  preparationSecondtPartSpeak: 'Boa sorte!',
  preparationSecondtPartTextToImage: 'Boa sorte!',
  preparationSecondtPartVocabulary:
    'Vamos ver se você conhece bem o seu vocabulário. <b>Boa sorte! </b>',
  preparationSpeaking:
    'Pratique a pronúncia de palavras ou frases novas. Clique no microfone azul e pronuncie-as. Em seguida, clique no microfone azul novamente quando terminar. Fale devagar.',
  preparationSpeakingMobile:
    'Pratique a pronúncia de palavras ou frases novas. Clique no microfone azul e pronuncie-as. Em seguida, clique no microfone azul novamente quando terminar. Fale devagar.',
  preparationTextToImage:
    'Essa é uma maneira divertida de praticar inglês! Leia e selecione a imagem correta.',
  preparationTextToImageMobile:
    'Essa é uma maneira divertida de praticar inglês! Leia e selecione a imagem correta.',
  preparationTextToText:
    'Divirta-se com palavras novas, gramática e leitura! Leia as frases ou as perguntas e selecione a resposta correta.',
  preparationTextToTextMobile:
    'Aprimore sua leitura, vocabulário e gramática selecionando a resposta correta para completar as perguntas a seguir.',
  preparationVocabulary: 'Pratique palavras novas! Siga as instruções e selecione a opção correta.',
  preparationVocabularyMobile:
    'Pratique palavras novas! Siga as instruções e selecione a opção correta.',
  privateTutor: 'Tutor particular',
  processing: 'Processando',
  profile: 'Perfil',
  progress: 'Progresso',
  provideClassCode: 'Forneça seu código de turma',
  question: 'Pergunta',
  questions: 'Perguntas',
  questionsAndConcerns: 'dúvidas e considerações.',
  questionsLeft: 'número de perguntas restantes',
  quiz: 'Atividade',
  quizzes: 'Quizzes',
  quizzesCompleted: 'Jogos concluídos',
  ran_out_of_time: 'Parece que seu tempo acabou novamente. Esta pergunta será marcada como',
  rateYourself: 'Avalie-se',
  readMore: 'Leia mais',
  readWithImageStartQuizInstructions: 'Leia o texto e responda às perguntas a seguir.',
  read_tip: 'Ler dica',
  readyToChooseYourAvatar: 'Pronto para escolher seu avatar?',
  refresh: 'Atualizar',
  registrationDealExpiredMessageDescription:
    'Entre em contato com o seu professor ou com o gestor escolar para obter orientações.',
  registrationDealExpiredMessageDescriptionAdmin:
    'Access through the website and our apps has been disabled for all users in your school. To renew your subscription and reinstate access, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
  registrationDealExpiredMessageDescriptionTeacher:
    'Please contact your school administrator for guidance.',
  registrationDealExpiredMessageTitle: 'O link expirou. 😕',
  registrationDealLimitReachedMessageDescription:
    'Entre em contato com o seu professor ou com o gestor escolar para obter orientações.',
  registrationDealLimitReachedMessageTitle: 'Esta escola atingiu o limite de usuários. 😕',
  reports: {
    activitiesCompletedInLevel: 'Atividades concluídas no nível {0}',
    allLevelsAvgTime: '📊 Tempo médio em todos os níveis',
    attemptsAndHints: 'Tentativas e Dicas',
    averagePerSkill: 'Média por habilidade',
    avgActivitiesCompleted: 'Média de atividades concluídas\n\n',
    avgAttempts: 'Tentativas',
    avgAttemptsPerActivity: 'Tentativas',
    avgFailureRate: 'Índice geral de reprovação',
    avgHintsPerActivity: 'Média de dicas por atividade',
    avgPassRate: 'Índice geral de aprovação',
    avgPerWeek: 'Média geral por semana',
    avgSkillScores: 'Pontuação nas habilidades',
    avgStreakLength: 'Frequência',
    avgStreakPerWeek: 'Média geral de frequência por semana',
    avgStudentProgress: 'Progresso dos alunos no nível atual',
    avgTimeSpent: 'Tempo gasto',
    continuousEngagement: 'Média de dias/semanas de empenho contínuo',
    daysPerWeek: '{0} dias por semana',
    engagedStudentsWord_one: 'engaged student',
    engagedStudentsWord_other: 'engaged students',
    engagement: 'Empenho',
    failureRate: 'Índice de reprovação',
    inCurrentLevel: 'No nível atual',
    longestStreak: 'Maior frequência',
    onActivities: 'Média de atividades por nível',
    overallProgressInLevel: 'Progresso geral no nível {0}',
    passRate: 'Índice individual de aprovação',
    perActivity: 'Média por atividade',
    perLevel: 'Média por nível',
    previous7Days: 'Últimos 7 dias',
    progress: 'Progresso',
    remark:
      'Estes dados representam <b>{0}</b> alunos engajados de um total de <b>{1}</b> alunos da turma.',
    skippedActivitiesComment:
      '* As atividades não concluídas estão incluídas no total de atividades',
    streakLast7Days: 'Frequência dos últimos 7 dias',
    streakLength: 'Frequência individual total',
    studentsOnlyWord_one: 'student',
    studentsOnlyWord_other: 'students',
    timeSpentOnActivites: 'Tempo gasto nas atividades',
    total: 'Total',
    totalHintsUsed: 'Total de dicas usadas',
    totalInPrev7Days: 'Total nos últimos 7 dias',
    totalStudents: 'Total de alunos',
  },
  requirements: 'Requisitos',
  resendVerificationCode: 'Não recebeu o código? Enviar código novamente',
  resetPassword: 'Redefinir senha',
  resetPasswordRequest: 'A solicitação de redefinição de senha foi enviada ao seu professor!',
  resolved: 'Ok, vamos lá!',
  results: 'Resultados',
  resume: 'Retomar',
  review: 'Revisar',
  reward: 'Recompensa',
  saturdayShort: 'Sáb',
  save: 'Salvar',
  schoolName: 'Nome da escola',
  score: 'Pontuação',
  scrollToTop: 'Voltar ao topo',
  searchClasses: 'Pesquise e/ou selecione uma opção',
  searchForStudent: 'Pesquisar aluno',
  searchStatus: 'Pesquisar status',
  selectAll: 'Selecionar todos',
  selfPracticeStreak: 'Frequência de prática do aluno',
  send: 'Enviar',
  sendNow: 'Enviar agora',
  settings: {
    about_me: 'Sobre mim',
    add_students: {
      add_student: 'Adicionar novo aluno',
      add_students_manually: 'Adicionar manualmente',
      button_next: 'Próximo',
      classCreatedDescriptionNoLevelTest:
        'Your students have been emailed instructions for resetting their password. Once your students log in, they will be placed at the default level and may begin their learning journey.',
      click_to_browse: 'clique para pesquisar',
      create_students: 'Os alunos a seguir receberão um e-mail de convite',
      download: 'Fazer download',
      download_sample: 'de um modelo de arquivo Excel (xlsx)',
      drag_here: 'Arraste um arquivo para cá ou ',
      email_will_be_send: 'Um e-mail com uma senha temporária será enviado para o aluno',
      enroll_students: 'Inscrever alunos',
      enrollment_unsuccessful: '⚠️ Matrícula não concluída!',
      enrollment_unsuccessful_description:
        'Os seguintes alunos não puderam se matricular porque seus e-mails já foram usados:',
      errors: {
        bad_formatting:
          'O arquivo não possui o formato correto. <br/> Verifique seus dados e faça as correções necessárias',
        email_in_use: 'Este endereço de e-mail já foi utilizado',
        email_incorrect: 'Insira um e-mail válido.',
        file_empty: 'O arquivo que você está tentando enviar está vazio',
        file_too_large: 'O arquivo é muito grande. O tamanho máximo permitido é de 256KB.',
        first_name_incorrect: 'Nome contém caracteres inválidos ou é muito longo.',
        first_name_missing: 'É necessário inserir o nome.',
        first_name_too_long: 'O nome pode ter até 30 caracteres.',
        last_name_incorrect: 'Sobrenome contém caracteres inválidos ou é muito longo.',
        last_name_missing: 'É necessário inserir o sobrenome.',
        last_name_too_long: 'O sobrenome pode ter até 40 caracteres.',
        limit_reached:
          'O número máximo de alunos por turma é de 50. <br/> Remova e faça upload de um novo arquivo.',
        limit_reached_description: 'Sua turma contém o número máximo permitido de alunos.',
        limit_reached_title: 'A turma está cheia.',
        max_number_of_students:
          'O número máximo de alunos por turma é 50. <br/> Remova e faça upload de um novo arquivo.',
        students_not_registered: 'Alguns alunos não foram inscritos',
        username_invalid: 'Nome de usuário já existe',
        username_missing: 'O nome de usuário é obrigatório.',
        wrong_format:
          'O formato do arquivo está incorreto. <br/> Certifique-se de que foi selecionado um arquivo Excel (xlsx).',
      },
      invite_students: 'Convidar alunos',
      not_enough_licenses_blocked_one:
        'Sua solicitação para adicionar 1 aluno foi bloqueada porque o limite de licenças da sua escola não poderá comportá-lo.',
      not_enough_licenses_blocked_other:
        'Sua solicitação para adicionar {{requested}} alunos foi bloqueada porque o limite de licenças da sua escola não poderá comportá-los.',
      not_enough_licenses_remaining_one:
        'Resta apenas 1 vaga. Você pode convidar menos alunos para preenchê-la ou entrar em contato conosco para obter ajuda.',
      not_enough_licenses_remaining_other:
        'Restam apenas {{available}} vagas. Você pode convidar menos alunos para preenchê-las ou entrar em contato conosco para obter ajuda.',
      not_enough_licenses_teacher_blocked_one:
        'Sua solicitação para adicionar 1 aluno foi bloqueada porque o limite de usuários da sua escola não poderá comportá-lo.',
      not_enough_licenses_teacher_blocked_other:
        'Sua solicitação para adicionar {{requested}} alunos foi bloqueada porque o limite de usuários da sua escola não poderá comportá-los.',
      not_enough_licenses_teacher_remaining_one:
        'Resta apenas 1 vaga. Você pode convidar menos alunos para preenchê-la ou entrar em contato com o seu gestor escolar para obter orientações.',
      not_enough_licenses_teacher_remaining_other:
        'Restam apenas {{available}} vagas. Você pode convidar menos alunos para preenchê-las ou entrar em contato com o seu gestor escolar para obter orientações.',
      partial_success: '⚠️ Sucesso parcial',
      partial_success_description:
        '{{addedStudents}}de {{totalStudents}} alunos se matricularam na turma. <br/>Eles receberão um e-mail com uma senha temporária.',
      upload_attention_text:
        '⚠️ Sua turma contém {{curent}}/{{limit}}alunos. <br/>Você pode matricular mais {{certified}} alunos.',
      upload_attention_text_new_class: '⚠️ Máx. de {{limit}}alunos por turma',
      upload_file: 'Carregue o arquivo de Excel com a lista de alunos',
      upload_successful: 'O upload do arquivo foi realizado com sucesso.',
    },
    class: 'Minha turma',
    current_level: 'Nível atual',
    delete_class: {
      areYouSure: 'Tem certeza?',
      cancel: 'Cancelar',
      classNotEmpty: 'Não é possível excluir uma turma que tenha alunos matriculados.',
      classNotEmptyDescription:
        'Caso queira excluir esta turma, primeiro exclua os alunos. Você pode fazer isso abrindo o perfil do aluno e clicando no ícone Editar.',
      delete: 'Excluir',
      deletingFailed: 'Tivemos um problema técnico.',
      deletingFailedDescription:
        'Nossos servidores não estão respondendo. Tente novamente. Caso o problema persista, entre em contato pelo e-mail:<a href="mailto:{{email}}">{{email}}</a>',
      description: 'Você está prestes a excluir a turma. Essa ação não pode ser desfeita.',
      tryAgain: 'Tente novamente',
    },
    delete_student: {
      areYouSure: 'Tem certeza?',
      cancel: 'Cancelar',
      choose: 'Selecione',
      delete: 'Excluir',
      deleteStudent: 'Excluir aluno',
      deletingFailed: 'Falha ao excluir.',
      deletingFailedDescription: '',
      description:
        'Excluir este aluno o removerá permanentemente da plataforma. Ele não poderá mais fazer login e todos os seus dados de progresso serão perdidos. Para isso, por gentileza, forneça um motivo:',
      reason: 'Motivo',
      reasons: {
        aClericalError: 'Erro administrativo',
        other: 'Outro',
        requestedToBeRemoved: 'O aluno ou pai solicitou a remoção',
      },
      why: 'Por quê?',
    },
    grade: 'Ano/Série',
    home: 'Página inicial',
    interface_language: 'Idioma da interface',
    language: 'Idioma',
    logout: 'Sair',
    my_classes: 'Minhas turmas',
    my_games: 'Meus jogos',
    my_students: 'Meus alunos',
    my_tutor: 'Meu tutor particular',
    native_language: 'Minha língua nativa',
    privacy_policy: 'Política de privacidade',
    profile: 'Perfil',
    school_id: 'Minha escola',
    security: 'Segurança',
    title: 'Configurações',
    username: 'Meu nome',
  },
  setupYourClass:
    'Configure sua turma e você receberá um código para enviar aos seus alunos. Eles farão um rápido cadastro e, em seguida, poderão fazer parte da sua turma!',
  signIn: 'Fazer login',
  signYouIn: 'Fazendo o seu login...',
  sign_out: 'Sair',
  sixDigits: '6 caracteres',
  sixDigitsAtLeast: 'O código deve ter pelo menos 6 caracteres',
  skills: {
    grammar: 'Gramática',
    listen: 'Compreensão auditiva',
    read: 'Leitura',
    speak: 'Expressão oral',
    spelling: 'Ortografia',
    vocabulary: 'Vocabulário',
  },
  skip: 'Pular',
  skipAllRecording: 'Ignorar todas as gravações',
  skipThisQuestion: 'pular pergunta',
  skipped: 'Ignorado',
  skippedPopUpSummary: {
    speak: {
      bannerTitle: 'Não concluída',
      description:
        'Essa atividade não foi concluída e, portanto, não será avaliada. Você pode voltar mais tarde para concluí-la.',
      title: 'Você optou por pular esta atividade',
    },
  },
  somewhatAgree: 'Concordo parcialmente',
  sortBy: 'Ordenar por:',
  soundAnalyzingSentences: {
    '0': 'Aguarde enquanto analisamos sua resposta',
    '1': 'Atividades de pronúncia podem ajudar você a aprender melhor o inglês',
    '2': 'Quase lá...',
    numberOfSentences: '3',
  },
  speak_tip: 'Dica de pronúncia',
  spelling_tip: 'Dica de ortografia',
  stars: 'Estrelas',
  start: 'Iniciar',
  startActivity: 'Iniciar atividade',
  startLevelTest: 'Iniciar teste de nivelamento',
  startNewConversation: 'Iniciar nova conversa',
  startQuiz: 'Iniciar jogo',
  startSkippedActivities: 'Iniciar atividades não concluídas',
  startingLevel: 'Nível inicial',
  startingReward: 'Recompensa inicial',
  state: 'Estado',
  status: 'Status',
  studentInstructions: 'Instruções para estudantes',
  studentMetricsDashboard: {
    charts: {
      avgScores: {
        subTitle: 'Pontuação média dos alunos por habilidade',
        title: 'Pontuações dos alunos',
      },
      avgStudentGrowth: {
        subTitle: 'Progresso médio cumulativo ao longo dos níveis por mês',
        title: 'Progresso total no nível',
        tooltipTitle: 'Progresso total no nível',
      },
      avgStudentProgressAtCurrentLevel: {
        levelInfo: 'Nível {{level}}\n({{studentCount}} alunos)',
        subTitle: 'Progresso médio dos alunos em cada nível',
        title: 'Progresso dos alunos no nível atual',
      },
      kpis: {
        averageTimeSpent: {
          label: '📊 Média do tempo gasto',
          tooltip: 'Média do tempo total gasto pelos alunos nos jogos.',
        },
        failureRate: {
          label: '🙁 Índice de reprovação',
          tooltip: 'Porcentagem das atividades reprovadas, puladas ou que não foram concluídas.',
        },
        passRate: {
          label: '✅ Índice individual de aprovação',
          tooltip: 'Porcentagem de tentativas em atividades concluídas com sucesso.',
        },
        studentsThatPassedLevel: {
          label: '🚀 Alunos que passaram de nível',
          tooltip: 'Número de alunos que foram aprovados ao menos em um nível.',
        },
        totalActivitiesPassed: {
          label: '🏆 Total de aprovações em atividades',
          tooltip:
            'Número de atividades únicas com aprovação por pontuação igual ou superior a 60.',
        },
        totalTimeSpent: {
          label: 'Tempo total gasto',
          tooltip: 'Soma do tempo gasto pelos alunos nos jogos.',
        },
      },
      studentLevelProgression: {
        levelInfo: 'Nível {{level}}\n({{studentCount}} alunos)',
        subTitle: 'Número de alunos em cada nível, mostrado por nível inicial',
        title: 'Progresso de nível do aluno',
        tools: {
          studentStartedAtL1: 'Iniciou no nível 1',
          studentStartedAtL2: 'Iniciou no nível 2',
          studentStartedAtL3: 'Iniciou no nível 3',
          studentStartedAtL4: 'Iniciou no nível 4',
          studentStartedAtL5: 'Iniciou no nível 5',
          studentStartedAtL6: 'Started at L6',
        },
      },
      studentsAcrossSkills: {
        subTitle: 'Porcentagem de alunos aprovados por habilidade',
        title: 'Sucesso dos alunos',
        tools: {
          failure: 'Reprovação (Abaixo de 60)',
          pass: 'Aprovação',
        },
      },
    },
    drillDown: {
      skills: {
        columns: {
          class: 'Turma',
          classNameAndGrade: 'Turma e ano/série',
          currentLevel: 'Nível atual',
          grade: 'Ano/série',
          name: 'Nome completo do aluno',
          nameAndTeacher: 'Nome e professor',
          skillGrammar: 'Gramática',
          skillListening: 'Compreensão auditiva',
          skillPronunciation: 'Média em pronúncia',
          skillReading: 'Leitura',
          skillSpeaking: 'Expressão oral',
          skillSpelling: 'Ortografia',
          skillVocabulary: 'Vocabulário',
          teacherNames: 'Nome(s) do(s) professor(es)',
        },
        loadingData: 'Carregando dados de habilidades...',
        title: {
          AvgScores: 'Pontuações dos alunos',
          StudentsAcrossSkills: 'Sucesso dos alunos',
        },
        totalStudents: 'Alunos engajados: {{totalStudents}}',
      },
      students: {
        allLevelsHint: 'Os dados refletem o desempenho dos alunos em todos os níveis.',
        columns: {
          class: 'Turma',
          completedActivities: 'Atividades concluídas',
          currentLevel: 'Nível atual',
          firstLogin: 'Primeiro login',
          grade: 'Ano/série',
          lastLogin: 'Último login',
          name: 'Nome completo do aluno',
          nameAndTeacher: 'Nome e professor',
          progress: 'Progresso',
          score: 'Pontuação',
          startingLevel: 'Nível inicial',
          teacherNames: 'Nome(s) do(s) professor(es)',
          timeSpent: 'Tempo gasto',
          totalActivities: 'Total de atividades',
        },
        levelHint: 'Os dados refletem o desempenho dos alunos em todos os níveis.',
        loadingData: 'Carregando dados do nível...',
        notAvailable: 'N/D',
        subTitle: '*O nível inicial foi alterado.',
        title: {
          AvgStudentGrowth: 'Progresso total no nível',
          AvgStudentProgressAtCurrentLevel: 'Progresso dos alunos no nível atual',
          StudentLevelProgression: 'Progresso de nível do aluno',
        },
        totalStudents: 'Alunos engajados: {{totalStudents}}',
      },
    },
    emptyState: {
      filter: {
        description: 'Os alunos não iniciaram nenhuma atividade durante o período selecionado.',
        title: 'Sem dados relativos ao período selecionado',
      },
      global: {
        description: 'Quando os alunos iniciarem as atividades, o progresso deles aparecerá aqui.',
        title: 'Sem atividades até o momento',
      },
    },
    exportData: {
      button: 'Exportar dados',
      fileName: 'Painel de métricas dos alunos',
      sheet: {
        levels: 'Níveis',
        skills: 'Habilidade ({{skill}})',
      },
    },
    filters: {
      completedActivities: 'Atividades concluídas',
      currentLevel: 'Nível atual',
      currentLevelSearchPlaceholder: 'Pesquisar nível',
      firstLogin: 'Primeiro login',
      grade: 'Ano/série',
      gradeSearchPlaceholder: 'Pesquisar ano/série',
      group: 'Nome da turma',
      groupSearchPlaceholder: 'Pesquisar turma',
      lastLogin: 'Último login',
      startingLevel: 'Nível inicial',
      startingLevelSearchPlaceholder: 'Pesquisar nível',
      studentName: 'Nome do aluno',
      studentNameSearchPlaceholder: 'Pesquisar aluno',
      teacher: 'Nome do professor',
      teacherSearchPlaceholder: 'Pesquisar professor',
      timeRange: 'Intervalo de tempo',
      timeSpent: 'Tempo gasto',
    },
    loadingMetrics: 'Carregando métricas...',
    pageTabs: {
      data: 'Dados',
      metrics: 'Métricas',
    },
    totalStudents: 'Alunos engajados: {{totalStudents}}',
  },
  studentName: 'Nome do aluno',
  studentProfile: 'Perfil do aluno',
  studentReport: 'Relatório do aluno',
  students: 'Alunos',
  studentsContent: {
    levelHint: 'Os dados refletem o desempenho dos alunos no nível atual.',
  },
  subject: 'Assunto',
  submit: 'Enviar',
  suggested_languages: 'Idiomas sugeridos',
  sundayShort: 'Dom',
  sync: 'Sincronizar',
  syncDataDescription:
    'Essa ação sincronizará as diferenças entre os dados do Hello e do Google Sala de Aula e incluirá as atualizações mais recentes.',
  syncYourData: 'Sincronize seus dados',
  synonyms: 'Sinônimos',
  tapToSpeak: 'Toque para falar',
  teacherInstructions: 'Instruções para professores',
  teacherLetsBeginn: 'Vamos começar!',
  teacherMobile: {
    classesMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
    studentsMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
    tutorMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
  },
  teacherName: 'Nome do professor',
  teachers: 'Professores',
  teachersThatHaveRegistered: 'Professores que se inscreveram',
  temporaryPassword: 'Senha temporária:',
  termsAndConditions: 'Termos e condições',
  testYourEnglish: 'Teste seu nível de inglês',
  thankYou: 'Obrigado!',
  thanksForSubmission: 'Obrigado por enviar sua resposta!',
  thats_the_way: 'É isso aí!',
  theAnswerIsIncorrectWhatWeHeardWas: 'A resposta está incorreta. O que ouvimos foi:',
  thisStudentIsInactive:
    'Este aluno está inativo. Ele foi convidado para a turma, mas ainda não alterou a senha temporária e não iniciou o teste de nivelamento.',
  thisStudentIsLevelTestIncomplete:
    'Este aluno ainda não completou o teste de nivelamento inicial. Ao finalizá-lo, você poderá visualizar seu progresso.',
  thisTopicWillHelpMe: 'Este tópico vai me ajudar',
  thursdayShort: 'Qui ',
  timeIsUp: 'Tempo esgotado!',
  timeSpent: 'Tempo gasto',
  tip: 'Dica!',
  tipsAndTricks: 'Dicas e sugestões',
  to: 'Para',
  toImproveYourVocabulary: 'Para melhorar seu vocabulário,',
  toNextQuestion: 'para a próxima pergunta',
  toggle: 'Alternar',
  topicProgress: 'Progresso do tópico',
  topics: 'Tópicos',
  totalActivities: 'Total de atividades',
  totalCoins: 'Total de moedas',
  totalHintsUsed: 'Total de dicas usadas',
  totalProgressWithinLevel: 'Progresso total dentro do nível',
  totalQuizzes: 'Total de jogos',
  totalTimeSpent: 'Tempo total gasto',
  totalTimeSpentTooltip: 'Soma do tempo gasto pelos alunos nos jogos.',
  totalTimeSpent_mobile: 'Tempo total gasto',
  tries: 'tentativas',
  tryAgain: 'Tente novamente',
  tryAgainBtn: 'Tente mais uma vez',
  tryAgainLater: 'Tente novamente mais tarde!',
  tryAgainOneMore: 'Tente novamente ou siga em frente',
  tryAgainOrKeepGoing: 'Tente novamente ou continue',
  tryBetter: 'Tente se esforçar mais na próxima vez',
  tryToGetAllStars: 'Desta vez, tente conseguir as três estrelas!',
  tuesdayShort: 'Ter ',
  tutorBack: '< Voltar',
  tutorCorrectAnswerIsShort: 'A resposta correta é <strong>{{answer}}</strong>',
  tutorEndActivityBtn: 'End Activity',
  tutorEndConversationBtn: 'Encerrar conversa',
  tutorNewConversation:
    '👋🏻 Hey {{name}}!\nYou\'re building <br class="desktop-br">stronger <span style="color: #05abf4" >grammar</span>\nand <span style="color: #ff9f4c">expression</span> skills!',
  tutorRouterPrompt: {
    activity: {
      cancelBtn: 'Continuar',
      confirmBtn: 'Encerrar conversa',
      description: 'Caso encerre a conversa, ela não ficará salva.',
      title: 'Você quer encerrar a conversa?',
    },
    cancelBtn: 'Let’s Keep Talking',
    confirmBtn: 'End Conversation',
    description: 'If you end it now, this conversation will not be saved.',
    fromCanDoBeforeStarted: {
      cancelBtn: 'Continue with Tutor',
      confirmBtn: 'I’m sure',
      title: 'Are you sure you don’t want to review {{topicName}}?',
    },
    title: 'End the conversation?',
  },
  uncorrectPronounce: 'Tente novamente ou pule para a próxima pergunta.',
  understandingYourEnglishLevel: 'Estamos começando a entender seu nível de inglês.',
  unfortunately:
    'Infelizmente, você não passou, portanto não receberá nenhuma moeda por esse jogo.',
  university: 'Universidade',
  update: 'Atualização',
  uploadCsvErrorModalDescription:
    'Talvez sua conexão com a internet esteja com problemas.<br />Tente novamente.',
  uploadCsvErrorModalTitle: 'Upload falhou',
  useTheCoins: 'Use as moedas que você ganhou para obter dicas',
  userDataSuccessfullyUpdated:
    'Os detalhes foram atualizados com sucesso. Solicite ao aluno que encerre a sessão e faça o login novamente para ver as alterações.',
  userStreak: {
    subTitle: 'Pratique todos os dias para se tornar um MESTRE',
    title: 'Mantenha a frequência!',
  },
  username: 'Nome de usuário',
  usernameAlreadyExists: 'Este nome de usuário já existe',
  usernameTooLong: 'Nome de usuário muito longo',
  usingYourMicrophone:
    'Usando seu microfone, fale devagar e com clareza e certifique-se de que não haja barulho de fundo.',
  validation: {
    code_required: 'O código é necessário',
    confirm_password_required: 'É necessário confirmar a senha',
    email_required: 'O e-mail é necessário',
    password_required: 'A senha é necessária',
    username_or_email_required: 'Nome de usuário ou e-mail é obrigatório',
  },
  validationCodeInvalid: 'Código de validação inválido',
  verificationCode: 'Código de verificação',
  verificationCodeResentCheckEmail:
    'A new verification code was sent to your email. Enter the latest code below.',
  verificationCodeSent: 'Um código de verificação foi enviado para',
  viewAnswerChoices: 'Exibir opções de resposta',
  vocabulary_tip: 'Dica de vocabulário',
  waitingForStudentsDescription: 'Você poderá vê-los logo após entrarem na plataforma!',
  waitingForStudentsToJoin: 'Aguardando que seus alunos entrem!',
  warningTemporaryPassword: 'Observe que a senha temporária será válida por 7 dias!',
  weAreAnalyzing: 'Estamos analisando sua redação. Aguarde alguns segundos...',
  weCouldNotProduce: 'Não foi possível produzir o relatório no momento.',
  weStillDontHaveAll:
    'Ainda não temos todas as informações necessárias ou há uma falha temporária.',
  we_want_to_know: 'Queremos saber seu nível',
  wednesdayShort: 'Qua',
  welcome: 'Bem-vindo',
  welcomeConfetti: 'Bem-vindo!',
  welcomeTo: 'Bem-vindo a',
  wellDone: 'Muito bem',
  wordCount: 'Número de palavras: {{wordCount}}',
  words: 'Aprenda inglês',
  wordsList: 'Lista de palavras',
  wow: 'Uau',
  wow_score_all_stars:
    'Uau! Você obteve uma pontuação de <b>{{score}}</b> e ganhou todas as estrelas.',
  writeClassNameHere: 'Escreva o nome da turma aqui',
  writeHere: 'Escreva aqui',
  writeOrSay: 'Escreva ou pronuncie sua resposta aqui...',
  wrongAnswer: 'Resposta errada!',
  yes: 'Sim',
  yesDelete: 'Sim, excluir',
  youAlmostThere: 'Você está quase lá...',
  youAreDoingGreatLetsKeepGoing: 'Você está indo bem! <br/>Vamos continuar.',
  youAreOnYourWay: 'Você está no caminho certo!',
  youCanCreateMore: 'Você pode criar mais de uma turma',
  youCanPractice:
    'você pode praticar palavras por meio de jogos ou usando cartões de memorização e uma lista.',
  youHaveCompleted: 'Você concluiu o tópico!',
  youMayNowShare: 'Agora você pode compartilhar o link com seus',
  youPassedTheQuiz:
    'Você concluiu a atividade com uma pontuação de <b>{{score}}</b>! Bom trabalho!',
  youPracticed: 'Você praticou. Você estudou.',
  youWillLose: 'Você vai perder',
  you_did_it: 'Você conseguiu!',
  you_got_a_score_try_again:
    'Você obteve uma pontuação de <b>{{score}}</b> dessa vez. Tente novamente para ganhar mais estrelas.',
  you_got_no_extra_stars: 'Você tirou <b>{{score}}</b> novamente.',
  your: 'Suas',
  yourClasses: 'Turmas',
  yourMessageHasBeenSentSuccessfully:
    'Sua mensagem foi enviada com sucesso. Obrigado por compartilhar seu valioso feedback conosco!',
  yourMessageHere: 'Sua mensagem aqui',
  yourPasswordHere: 'Sua senha aqui',
  yourPhoneHere: 'Seu telefone aqui',
  yourSchoolHasBeenCreated: 'Sua escola foi criada com sucesso',
  yourStreak: 'Sua frequência',
  yourStudentQuiz:
    'Este é o quiz que seus alunos realizarão quando entrarem no aplicativo pela primeira vez. Sinta-se à vontade para respondê-lo agora ou mais tarde.',
  yourStudentsHaveNotJoined: 'Sem alunos ativos',
  yourSubjectHere: 'Seu assunto aqui',
};
